// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spot-container {
    color: var(--white-color);
}


@media (min-width: 1920px) {

    .trade_body .fluid-header {
        padding: 4px 0;
    }
}

@media (max-width: 1499px) {
    .trade_body .fluid-header {
        padding: 5px 15px;
    }

}


.price_item_value .td_div img {
    width: 20px;
    margin-right: 5px !important;
}

.trade-wrapper {
    padding-top: 10px !important;
}

/* Mobile Favourites Popup - Hidden by default (desktop/tablet) */
.mobile-favourites-popup-overlay {
    display: none;
}

/* Mobile Favourites Toggle Button - Hidden by default */
.mobile-favourites-toggle-btn {
    display: none;
}


.spot-container-main {
    display: flex;
    flex-direction: column;
    /*padding: 0 15px;*/
    flex: 1 1;
}

.spot-container-main .top {
    display: flex;
}

.trade_row {
    margin: 0 0;
}

.trade_col {
    padding: 0 5px;
    width: 100%;
}




.spot-container-main .top-left {
    flex-grow: 1;
}

.spot-container-main .top-right {
    width: 380px;
}


div#TVChartContainer,
div#TVChartContainer * {
    border-radius: 10px;
    overflow: hidden;
}

.container-chart-briefing {
    height: 80px;
    position: relative;
    justify-content: flex-start;
    width: 100%;
    padding: 20px;
    display: flex;
    align-items: center;
}



.text-danger {
    color: #E45561 !important;
}

.trade_card,
.spotLists {
    background: #181A20;
    border: none;
    border-radius: 0px;
    overflow: hidden;
    /* backdrop-filter removed: background is opaque so the blur is invisible
       but still forces a GPU re-blur every scroll frame (scroll-jank source) */
    position: relative;
    color: #fffffff2;
}


body.light_theme.trade_card,
body.light_theme.spotLists {
    background-color: #ffffff;
    border: 1px solid #7878781a;
    /* backdrop-filter removed: opaque background, blur not visible */
}

.container-chart-briefing-info {
    font-size: 12px;
    text-align: left;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

dd,
dl,
dt {
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    line-height: 1.5;
    font-weight: 500;
}

.container-chart-briefing h2 {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    padding-right: 20px;
    cursor: pointer;
    font-weight: 700;
    color: #ffffff;
}

.container-chart-briefing-info dd.big,
.container-chart-briefing-info dt.big {
    font-size: 18px;
    font-weight: 700;
}

.container-chart-briefing-info dd.green,
.container-chart-briefing-info dt.green {
    color: #01BC8D !important;
}

.container-chart-briefing .displayName>span {
    padding-right: 10px;
}


.trade-wrapper .btn {
    justify-content: center;
}

dd {
    font-weight: 600;
}




.tv-chart {
    width: 100%;
    height: 507px;
}


/*order book*/

.card_title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    padding-bottom: 1rem;
    color: currentColor;
}


.trade_tabs {
    padding: 10px;
}

.trade_card_body.single-widget ul li a {
    font-size: 14PX;
}

.price_card_head {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: "Roboto", sans-serif;
    line-height: 12px;
    justify-content: space-between;
    height: 24px;
    color: #87909F;
    line-height: 24px;
    /* border-bottom: 1px solid #2b2f39 */
}


.price_card_body::-webkit-scrollbar,
.scroll_y::-webkit-scrollbar {
    width: 3px;
    background-color: transparent;
}

.price_card_body::-webkit-scrollbar-thumb,
.scroll_y::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgb(106 106 106 / 21%);
}

.price_item_value {
    display: flex;
    position: relative;
    z-index: 1;
    color: #F2F4F6;
    font-family: "Roboto", sans-serif;
    width: 100%;
    padding: 2px 0;
    justify-content: space-between;
    font-weight: 400;
    align-items: center;
}

.price_item_value:hover {
    background: #ffffff14;
}

body.light_theme.trade-wrapper {
    background-color: #f5f5f55e;
}

body.light_theme.price_item_value {
    /* border-bottom: 1px solid rgb(0 0 0 / 5%); */
    border-color: #58585814;
}

.price_item_value span {
    display: block;
    /*color: #ffffff;*/
    font-size: 11px;
}

/* 
.price_item_value span.text-green,
.price_item_value span.text-danger {
    font-weight: 400;
}

.price_item_value span:first-child,
.price_card_head>div:first-child {
    display: block;
    width: 33.33333%;
    padding-left: 10px;
}

.price_item_value span:nth-child(2),
.price_card_head>div:nth-child(2) {
    display: block;
    width: 33.33333%;
    text-align: center;
}

.price_item_value span:last-child,
.price_card_head>div:last-child {
    display: block;
    width: 33.33333%;
    text-align: right;
    padding-right: 10px;
    font-weight: 500;
} */


.price_item_value:last-child {
    /* border: 0; */
}

.live_ppc {
    font-weight: 500;
    padding: 1rem 0;
    line-height: 1;
}

.price_card_body.price_card_body_full,
.scroll_y {
    height: 450px;
    overflow-y: auto;
    overflow-x: hidden;
}

.buy_sell_row_price .scroll_y {
    height: 230px;
}

.buy_sell_row_price #buy_orders .scroll_y,
.buy_sell_row_price #sell_orders .scroll_y {
    height: 520px;
}

.buysell_card {
    /* height: 533px; */
}

.spot-container-right-right {
    flex: 0 0 300px;
    max-width: 300px;
}

.scroll_y_mt {
    height: 322px;
}

div#tab_3 {
    height: 91%;
    margin-top: 63px;
}

.trade_card.p-2.overflow_card.mb-1 {
    width: calc(100% + 33.50%);
}

.order-4 {
    margin: 0;
}


.assets_list {
    /* width: 100%; */
    margin: 57px 21px 20px;
    position: relative;
    z-index: 666;
}

.trade_card.trade_chart.buysell_card .assets_list {
    margin: 0px 21px 20px;
}

.assets_list ul {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
    color: #fff;
}

.assets_list ul li {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.assets_btn {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin: 20px 0px;
}

.assets_btn button {
    width: 100%;
    background-color: #2B313C;
    color: #F2F4F6;
    border: none;
    font-size: 14px;
    padding: 7px 16px;
    border-radius: 50px;
}

.assets_list h4 {
    font-size: 18px;
    font-weight: 500;
}

.assets_list .top_heading {
    margin-bottom: 10px;
}

.assets_list .more_btn {
    margin: 0px;
}


.trade_chart .form-select-sm {
    padding: 9px 10px !important;
    font-size: 12px;
    background: #22242c;
    border-radius: 4px !important;
    border-color: #2d303a00;
    box-shadow: none;
    color: #F2F4F6;
}

.buysellform>p {
    margin: 7px 0 11px;
    font-size: 14px;
}

.btn-mini {
    font-size: 13px !important;
    padding: 7px;
    font-weight: 600;
}

.buy_sell_cards ul.nav.custom-tabs {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Roboto", sans-serif;
    padding: 0;
    box-shadow: none !important;
    background: transparent !important;
    width: 100%;
    -webkit-backdrop-filter: unset !important;
            backdrop-filter: unset !important;
}

.buy_sell_cards ul.nav.custom-tabs.nav_order li {
    /* max-width: fit-content; */
    flex: 1 1 auto;
    text-align: center;
}


.buy_sell_cards ul.nav.custom-tabs li a {
    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */
    display: block;
    text-align: center;
    border-radius: 40px;
    padding: 4px 6px;
    color: #fff;
    background-color: #ffffff1a !important;
    font-size: 13px;
    font-weight: 500;
    margin: 0 3px;
}

.buy_sell_cards ul.nav.custom-tabs li a.active {
    color: #000 !important;
    background-color: #fea903 !important;
    opacity: 1 !important;
}

.buy_sell_cards ul.nav.custom-tabs li a.active {
    color: #e9e9e9 !important;
}

body.light_theme.buy_sell_cards ul.nav.custom-tabs li a {
    background-color: #f1f4f4;
    color: rgba(0, 0, 0, 0.75);
}

.custom-tabs li.buy-tab a:hover {
    color: rgba(255, 255, 255, 0.75);
    /*background-color: var(--bs-green)54;*/
}

.custom-tabs li.sell-tab a:hover {
    color: rgba(255, 255, 255, 0.75);
    /*background-color: #fe535b2b;*/
}

.custom-tabs li.buysell-tab a {
    cursor: pointer;
}

.buysell_heder .custom-tabs li a {
    cursor: pointer;
}

/* .custom-tabs li.sell-tab a.active,
.custom-tabs li.sell-tab a:active {
    color: #fff !important;
    background-color: #ed5765 !important;
} */

button.btn.btn-danger {
    color: #fff !important;
    background-color: #E45561 !important;
}

/* .custom-tabs li.buysell-tab a.active {
    color: #fff !important;
    background: #01BC8D !important;
} */

.text-green {
    color: #01BC8D;
}

.spot-deal-warp {
    margin-top: 25px;
}

.custom-tabs {
    color: var(--white-color);
    background: #ffffff1c;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    padding: 4px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 50px;
    display: inline-flex;
}

.headline_bigName__dspVW h1 i {
    display: none;
}

.spot .input-group {
    background: transparent;
    border-radius: 40px;
    overflow: hidden;
    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */
}

.spot .input-group>span {
    text-align: center !important;
}

.spot .input-group>span small {
    text-align: center;
    margin: 0 auto;
}

.input-group-text {
    /*background-color: #20202d0d;*/
    /* border: 1px solid #20202d; */
    border-radius: 0;
    color: currentColor;
    line-height: 1.2;
    min-width: 76px;
    font-weight: 500;
    border: 0;
    background: transparent;
}

.input-group-text small {
    font-size: 75%;
}

.spot .form-control,
.spot select {
    color: currentColor;
    background-color: #2f2f39;
    border: 0;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    border-radius: 3px !important;
    background: #ffffff17;
    color: #ffffff;
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border: 1px solid #ffffff1c;
    padding: 7px 18px;
    min-width: unset;
    border-radius: 50px !important;
}

body.light_theme.spot .form-control {
    background-color: transparent;
}

.form-control:focus {
    box-shadow: none;
}

.btn-group.btn-group-mini {
    width: 100%;
    border-radius: 0 !important;
    border: 0;
    background: transparent;
    margin-left: auto !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
}

.btn-group.btn-group-mini * {
    border-block: none;
    /* line-height: 24px; */
    font-size: 12px !important;
    font-weight: 400;
    border: 0;
    transition: 0.0s;
    padding: 15px 0px 0px;
    color: #535963 !important;
    margin: 0 auto !important;
    width: -webkit-fill-available;
    text-align: left;
    display: grid;
    min-height: auto;
    box-shadow: none !important;
    /* height: 24px; */
    /* border-radius: 0px !important; */
    background: none;
    /* border: 1px solid #2d303a; */
    /* backdrop-filter removed: applied via universal (*) selector to every
       child, creating a blur layer per element — costly with no visible gain */
    /* min-width: 36px; */
    opacity: 1;
}

/* .btn-group.btn-group-mini label.btn:hover{ background: #22242c !important; color: #f3bb2b !important; }  */

body.light_theme.btn-group.btn-group-mini * {
    background: rgb(171 171 171 / 12%);
    border: 1px solid rgb(234 239 244);
    /* backdrop-filter removed: costly universal (*) selector */
    color: #000;
}


.btn-check:active+.btn-outline-success:focus,
.btn-check:checked+.btn-outline-success:focus,
.btn-outline-success.active:focus,
.btn-outline-success.dropdown-toggle.show:focus,
.btn-outline-success:active:focus {
    box-shadow: none !important;
}

.btn-group.btn-group-mini *:focus {
    background: transparent;
}

.data-buy .btn-group.btn-group-mini .btn-outline-success {}

.data-sell .btn-group.btn-group-mini .btn-outline-danger {}

.btn-dark {
    background: #ffffff26;
}

.btn-check+.btn:hover {
    color: #ffffff;
}

.btn-check+.btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: non;
}

.data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,
.data-buy .btn-group.btn-group-mini .btn-outline-success:hover,
.data-buy .btn-group.btn-group-mini .btn-outline-success.active {
    background: #00000000;
    border-color: #00000000;
}

.data-buy .btn-group.btn-group-mini .btn-outline-success.active {
    background: rgba(2, 192, 118, 0.15) !important;
    border-color: #fff !important;
    color: #fff !important;
}

.data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,
.data-sell .btn-group.btn-group-mini .btn-outline-danger:hover,
.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {
    background: #00000000;
    border-color: #00000000;
}

.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {
    background: rgba(228, 85, 97, 0.15) !important;
    border-color: #fff !important;
    color: #fff !important;
}

html[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,
html[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success:hover,
html[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,
html[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger:hover {
    background: #ffffff00 !important;
    border-color: #ffffff00 !important;
}

html[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success.active {
    background: rgba(2, 192, 118, 0.15) !important;
    border-color: #02c076 !important;
    color: #ffff !important;
}

html[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger.active {
    background: rgba(228, 85, 97, 0.15) !important;
    border-color: #E45561 !important;
    color: #ffff !important;
}




/* .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-success{ 
      border-color: var(--bs-green) !important;
  }
  .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-danger{ 
      border-color: var(--bs-red) !important;
  } */


.trade-wrapper select,
.trade-wrapper .nice-select {
    box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px;
    height: 44px;
    background: #ffffff1a;
    color: var(--white-color);
    width: 100%;
    /* backdrop-filter: blur(10px); */
    border-radius: 50px;
    padding: 0 16px;
}

body.light_theme.trade-wrapper select,
body.light_theme.trade-wrapper .nice-select {
    box-shadow: rgb(106 106 106 / 9%) 0px 0px 0px 1px;
    background: rgb(245 245 245);
}

.trade-wrapper select *,
.trade-wrapper .nice-select * {
    /* font-size: 13px; */
    color: #ffffff !important;
    background: #000;
}

body.light_theme.trade-wrapper select *,
body.light_theme.trade-wrapper .nice-select * {
    color: #333333 !important;
    background: #ffffff;
}

.num-select,
.num-select:focus {
    color: #fff !important;
}

.btn-block {
    display: block;
}

small.note {
    font-size: 74%;
    display: block;
    text-align: center;
    margin: 18px 12px 0;
    line-height: 1.2;
}

.buy_sell_cards button {
    margin: 1.5rem 0 1rem;
}

.btn-group.btn-group-mini label.last-child {
    text-align: right;
    width: auto;
}

.btn-group.btn-group-mini label.last-child::before {
    right: 0px;
    left: inherit;
}

.trade_assets {
    margin-top: 1rem;
}

.trade_assets .product-owner {
    padding: 0.5rem 0;

    border-bottom: 1px solid #2f2f39;
}

.trade_assets .product-owner:last-child {
    border-bottom: 0;
}

body.light_theme.trade_assets .product-owner {
    border-color: rgb(0 0 0 / 5%);
}


.trade_card table.table,
.trade_card tbody tr:hover {
    background-color: transparent !important;
}


.form-select-sm {
    padding: 9px 6px !important;
    height: unset !important;
    /* width: min-content !important; */
    /* min-width: unset !important; */
}

.treade_card_header.tch_main_tab {
    display: none;
}

.trade_card .table> :not(caption)>*>* {
    padding: .5rem .5rem;
    line-height: 1.5 !important;
    vertical-align: middle;
    font-size: 11px;
    font-weight: 300;
}

.trade-wrapper .orderbook-table {
    position: relative;
}

.trade-wrapper .orderbook-table th {
    font-size: 12px;
    align-items: start !important;
    font-weight: 300;
    color: #87909F;
    position: static;
    padding: 4px 10px;
    top: 0;
    z-index: 5;
    background-color: #181a20 !important;
}


.trade_card .table>.btn {
    margin: 0;
}


.spot-container-main .bottom {
    display: flex;
    min-height: 500px;
    /*border-top: 1px solid #191e23;*/
    flex: 1 1;
}


.bottom-left {
    width: calc(100% - 380px);
}

.bottom-right {
    width: 380px;
}

ul.nav.custom-tabs.order_his_tabs li {
    max-width: -webkit-fill-available;
    width: auto;
    padding: 0;
}

ul.nav.custom-tabs.order_his_tabs {
    justify-content: flex-start;
}

ul.nav.custom-tabs.order_his_tabs li a {
    padding: 8px 13px;
    height: unset !important;
    line-height: 1;
}

.ant-list-item {
    display: flex;
    height: 42px;
    padding: 5px 16px;
    cursor: pointer;
}

.rankItem {
    height: 27px;
    line-height: 12px;
    width: 144px;
}





/* .spotLists {
    width: 360px;
    min-height: 360px;
    max-width: calc(100% - 12px);
    padding-bottom: 10px;
    overflow-y: auto;
    overflow-x: hidden; 
    position: absolute;
    top: 128px;
    left: 12px;
    z-index: 111111;
    border-radius: 9px;
    display: none;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    padding: 0;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
} */

.spotLists {
    width: 100%;
    min-height: 360px;
    max-width: calc(100% - 12px);
    padding-bottom: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    /* background: #ffffff12; */
    /* position: absolute; */
    /* top: 128px; */
    /* left: 12px; */
    z-index: 111111;
    border-radius: 9px;
    display: none;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
    padding: 0;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    max-width: 550px;
}


.spotLists.active {

    display: block !important;

}

.show_spot {
    display: block !important;
}

.spotList .scroll_y {
    height: 357px;
}

.spot-list {
    position: absolute;
    left: 0;
    top: 0;
    width: 360px;
    min-height: 100%;
    background: #1f252a;
}

.spot-list-search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 10px;
    padding-top: 0;
}

.spot-list-search .ivu-input {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 0 12px;
}

body.light_theme.spot-list-search .ivu-input {
    background: rgb(241 244 244);
    border: 1px solid rgb(241 244 244);
}

.container-chart-briefing-info h6 {
    font-size: 16px;
}

.spot-list-search i {

    margin-right: 14px;
}

.spot-list-search .ivu-input input {
    background: transparent;
    border: 0;
    outline: 0 !important;
    color: var(--white-color);
    padding: 6px 3px;
    font-size: 14px;
    width: 100%;
}

body.light_theme .spot-list-search .ivu-input input {
    color: #424242;
}

.spot-list-search .ivu-input input:focus {
    border: none !important;

}

.price_card {
    padding: 10px 0;
    padding: 0;
}

.price_card .price_card_head {
    padding: 0 15px;
}

.price_card_body {
    padding: 0 10px;
}

.trade_history_tab .price_card_body {
    padding: 0 15px;
}

#buy_orders .price_card_body.scroll_y.center_cntr {
    justify-content: start;
}

#sell_orders .price_card_body.scroll_y.center_cntr {
    justify-content: start;
}

.subhead_cntr {
    font-size: 12px;
    font-weight: 300;
    justify-content: start;
    text-align: left;
    line-height: 15px;
    color: #fff;
}

span.tokensubcnt {
    color: #949AA4;
    font-size: 12px;
}

.trade_favourites_lft img.round_img {
    width: 24px !important;
    height: 24px !important;
}

.price_cntr_star i {
    color: #565A62;
    font-size: 17px !important;
}

.trade_favourites_lft .price_item_value {
    padding: 10px
}

.price_cntr_star {
    gap: 7px;
}

.trade_history_tab .price_card_head {
    padding: 0px 15px;
}

.price_card_body.scroll_y {
    padding-right: 5px;
    padding-left: 5px;
}

.price_item_value .ri-xl {
    font-size: 116%;
}

.spot-list-search .ivu-input::placeholder {
    color: #ffffffde;
}

.buy_sell_cards ul.nav.custom-tabs li a.active {
    color: #000 !important;
    background-color: #fea903 !important;
}


body.light_theme.container-chart-briefing .spotList {
    background: #ffffff;
    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;
}


.trade-wrapper .favouriteData {
    text-align: center;
    padding: 5% 0;
    /* font-size: 300%; */
}

html[data-theme='dark'] .trade-wrapper .favouriteData p {
    color: #ffffff;
    margin: 10px 0px;
}


.scroll_y .favouriteData {
    height: 100%;
}


.btn.btn-warning {
    background-color: #f3bb2b !important;
    color: #222222 !important;
    border-radius: 50px !important;
}

.mrkt_trde_tab {
    display: flex;
    align-items: center;
    justify-content: start !important;
    font-size: 18px;
    padding: 8px;
    margin: 00;
    text-align: left;
    background: #22242c00;
}

.option_datatable_bl .classic_favorites_bl .order_trade_s .table-trade {
    padding: 0px 0px;
}

.option_datatable_bl .order_trade_s .buy_sell_row {
    padding: 10px 10px 0px;
}

.option_datatable_bl .order_trade_s .price_card_head {
    padding: 0px 10px;
}

.option_datatable_bl .buy_sell_row_price .scroll_y {
    padding: 0px 10px;
    height: 218px;
}

.trade-wrapper .text-success {
    color: #01BC8D !important;
}

body.light_theme.mrkt_trde_tab {
    background: #f5f5f5;
}




.buysellform .input-group {
    padding: 3px 10px;
    display: flex;
    align-items: center;
    background: #2B313C;
    border: 1px solid #2d303a00;
    border-radius: 4px;
    /* backdrop-filter removed: opaque background, blur not visible */
}

body.light_theme.buysellform .input-group {
    background: rgb(245 245 245);
    border: 1px solid rgb(234 239 244);
}

.trade-wrapper.spot .tab-content>.tab-pane {
    height: 100% !important;
}


.buysellform .input-group .form-control {
    background: transparent;
    border: 0;
    padding-left: 0;
    font-weight: 400;
    padding-right: 0;
    border-radius: 0 !important;
    font-size: 12.2px !important;
    -webkit-backdrop-filter: unset !important;
            backdrop-filter: unset !important;
}

.trade_card .table> :not(caption)>*>* {
    font-size: 12px;
    background-color: transparent;
    color: #F2F4F6;
}

table.table tbody tr:last-child td .favouriteData p {
    font-size: 14px;
}

.buysellform .input-group .input-group-text,
.buysellform .input-group .input-group-text * {
    padding: 0;
    margin: 0;
    text-align: right !important;
    display: block;
}


.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
    border-radius: 2px;
    margin: 0px;
    background: transparent !important;
    line-height: 1;
}


.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li {
    max-width: -moz-fit-content;
    max-width: fit-content;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs {
    justify-content: end;
    gap: 4px;
}



.buy_sell_row h6 {
    font-size: 12px;
}

.buy_sell_row {
    border-bottom: 1px solid #ffffff1a;
    margin-bottom: 10px;
    padding: 10px 10px;
}

body.light_theme.buy_sell_row {
    border-bottom: 1px solid #d2e4ff;
}

.actv_data p,
.actv_data span {
    font-size: 13px;
}


.trade-wrapper .row {
    margin-left: -5px;
    margin-right: -5px;
}

/* .trade-wrapper .row > * {
        padding-left: 5px;
        padding-right: 5px;
    }
   */
.trade-wrapper .mb-1 {
    margin-bottom: 5px !important;
}

.num-select {
    padding: 0 !important;
    background: transparent !important;
    border: 0 !important;
    width: 32px !important;
    outline: 0 !important;
    box-shadow: none !important;
    min-width: min-content !important;
    text-align: right;
    height: -moz-fit-content !important;
    height: fit-content !important;
    font-size: 13px;
    line-height: 1.1;
}

.num-select * {
    max-width: unset !important;
    color: currentColor;
}

body.light_theme.num-select * {
    color: #fff !important;
}

.num-div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: #2B313C;
    padding: 4px;
    border-radius: 4px;
}

.num-div .num-select {
    font-size: 11px;
    font-weight: 300;
    color: #999;
}

.num-div:after {
    font-family: "remixicon" !important;
    font-style: normal;
    content: "\\ea4d";
    color: #535963;
    font-size: 16px;
    /* position: absolute; */
    /* right: 0; */
    /* top: 0; */
    /* height: 15px; */
    line-height: 1;
}

.trade_summary_table_lft .num-div {
    background-color: transparent;
}

.freerate {
    background-color: #2B313C;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 10px 20px;
    border-radius: 4px;
    font-size: 12px;
    margin: 20px 0px 10px;
}

.freerate span {
    color: #949AA4;
}

body.light_theme.num-div:after {
    color: #333;
}

body.light_theme.num-div {
    background: #ffffff;
    color: #333 !important;
}

body.light_theme.num-div select {
    color: #333 !important;
}

.actv_sorting strong {
    font-weight: 500;
}


.price_item_value.active {
    background: #2B313C;
}

body.light_theme.price_item_value.active {
    background: #0000000d;
}

.trade_favourites_lft .spot-list-search .ivu-input {
    background: #565A62;
    border: none;
    border-radius: 8px;
    padding: 3px 12px;
}

.trade_favourites_lft .spot-list-search i {
    margin-right: 5px;
    color: #a9a9a9;
}

.trade-wrapper table tr td {
    font-size: 12px !important;
    font-weight: 300 !important;
    padding: 2px 10px !important;
}

.trade_favourites_lft .price_card_body {
    padding: 0px;
}

.trade_card.p-3 {
    padding: 11px !important;
}

.trade_favourites_lft .price_card .price_card_head {
    padding: 0 10px;
}

.assets_right .assets_list {
    margin: 10px 0px;
    padding-bottom: 2px;
}

.trade-wrapper .assets_right table tr td {
    padding: 4px 10px;
}


.assets_right .price_card_body.scroll_y {
    padding-right: 0px;
    padding-left: 0px;
}

/* trade new css */

.mt_tr_pr {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.mt_tr_pr .headline_bigName__dspVW i.faaa {
    font-size: 20px;
    opacity: 0.8;
    font-weight: 100;
    cursor: pointer;
    margin-left: 6px;
}

.mt_tr_pr .headline_bigName__dspVW i.ri-menu-add-line:hover {
    opacity: 1;
}

.spot-container {
    max-width: 1520px;
}

.bs_dropbox .summay_dasboard_pop {
    display: none !important;
}

.bs_dropbox .row .col-lg-6 {
    width: 100% !important;
    padding: 0px;
}


.bs_dropbox .trade_card.trade_chart.buysell_card {
    width: 96.5%;
    min-height: 722px;
    position: relative;
    left: 5px;
}

.treade_card_header {
    border-bottom: 1px solid #2b2f39;
    display: flex;
    align-items: center;
    padding-inline-start: 5px;
    flex-shrink: 0;
}

.tch_main_tab {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
}

.tch_main_tab::-webkit-scrollbar {
    display: none;
}

body.light_theme .treade_card_header,
body.light_theme .price_card_head {
    border-bottom: 1px solid #dadada;
    opacity: 1;
}

body.light_theme .card_header_title:before {
    background-color: #cacaca;
}

body.light_theme .card_header_title.active {
    color: #3f3f3f;
}


body.light_theme .headline_left__lBBPY .headline_symbolName__KfmIZ {
    color: #262626;
}

body.light_theme ul.favorites_list_tabs li button.active {
    color: #525252;
    border-bottom: 2px solid #5a5a5a;
}

.card_header_title {
    height: 38px;
    line-height: 38px;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    font-weight: 400;
    color: #949AA4;
    font-family: "Roboto", sans-serif;
}

.trade_favourites_lft .spotLists {
    display: block;
    border-radius: 0px;
    height: 99.6%;
    padding-top: 12px;
}

.trade-wrapper .table-responsive {
    min-height: 300px;
    max-height: 570px;
}

.trade-wrapper div#tab_3.d-none.d-lg-block .table-responsive {
    min-height: 570px; }

.trade-wrapper div#tab_3.d-none.d-lg-block tr.no-data-row {
        width: 100%;
        height: 100%;
        text-align: center;
        display: contents;
        justify-content: center;
        align-items: center;
    }

.trade_card button.btn.btn-success {
    color: #fff !important;
    background-color: #5EBA89 !important;
    border-radius: 50px;
    font-size: 12px;
    padding: 7px 16px;
    border-color: #5EBA89;
}

.trade_card small {
    font-size: 12px;
    color: #949AA4;
    padding-bottom: 10px;
    margin-bottom: 0px !important;
    display: block;
}

.spot_limit {
    border-bottom: 1px solid #393F4F;
}

.spot_limit button {
    background: transparent;
    border: 0;
    border-bottom: 2px solid #ffffff00;
    padding: 0 0px 8px;
    font-size: 14px;
    font-weight: 400;
    color: #949AA4;
}

.spot_limit button.active {
    border-bottom: 2px solid #fff;
    color: #fff;
}

.mrkt_trde_tab span {
    font-size: 14px;
    color: #87909F;
}

.trade-wrapper .assets_list .top_heading {
    justify-content: space-between;
    align-items: center;
}

.assets_list .more_btn {
    font-size: 12px;
    color: #d3d3d3;
}

.trade-wrapper .assets_list h4 {
    font-size: 15px;
    font-weight: 400;
    color: #dbdbdb;
    margin: 0px;
}

.assets_btn button a {
    color: #F2F4F6;
    font-weight: 300;
}

.card_header_title:before {
    position: absolute;
    content: " ";
    width: 100%;
    height: 2px;
    border-radius: 0px;
    background-color: #F2F4F6;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%) scaleX(.5);
    opacity: 0;
    transition: all .16s ease-in;
}

.card_header_title.active {
    color: #F2F4F6;
}

body.light_theme.card_header_title.active {
    color: #000000;
}

.card_header_title.active:before {
    opacity: 1;
    transform: translateX(-50%) scaleX(1);
}

.nav.custom-tabs.nav_order {
    width: auto !important;
}

.trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* height: 26px; */
    padding: 10px 15px 5px;
    border: 0;
    margin: 0;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {
    background: transparent !important;
}

.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {
    background: #262933 !important;
}

body.light_theme.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {
    background: #e9e9e9 !important;
}

body.light_theme.price_card_head {
    border-color: #00000012;
}

.scroll_y_hidden {
    overflow: hidden;
}



.headline_left__lBBPY {
    display: flex;
    align-items: center;
}

.headline_left__lBBPY .headline_symbolName__KfmIZ {
    white-space: nowrap;
    margin-right: 0;
    cursor: pointer;
}

.headline_bigName__dspVW {
    display: flex;
    align-items: center;
    margin-inline-end: 7px;
}

.headline_bigName__dspVW,
.headline_bigName__dspVW h1 {
    line-height: 20px;
    font-size: 14px !important;
    font-weight: 600;
}

.headline_bigName__dspVW h1 {
    margin: 0;
}

.headline_etfDisplay__P4Hdv {
    font-size: 10px;
    line-height: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-inline-end: 10px;
    opacity: 0.7;
}

.headline_leftItem__7BFYq {
    margin-inline-start: 15px;
    font-size: 12px;
    color: #949AA4;
    line-height: 20px;
    white-space: nowrap;
    font-weight: normal;
    font-weight: 400;
}



/* token info */

.inf_row {
    padding: 1.5rem;
}

.inf_row .mt_tr_pr {
    margin-bottom: 16px;
}

.inf_row .headline_bigName__dspVW,
.headline_bigName__dspVW h1 {
    font-size: 14px !important;
}


.infor_row li {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.infor_row li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    padding: 8px 0;
}

.infor_row li span {
    font-weight: 500;
    color: #fff;
}

body.light_theme.infor_row li span {
    color: #000;
}


.orderbook_two .buy_sell_row_price .scroll_y {
    height: 257px;
}

.t_info h5 {
    font-size: 15px;
    font-weight: 600;
}

.t_info p {
    font-weight: 300;
    font-size: 13px;
}

.inf_row {
    padding: 1.5rem;
    height: 429px;
    overflow-y: auto;
}

@media (min-width:1601px) {
    .headline_leftItem__7BFYq {
        margin-inline-start: 30px;
    }

}

.headline_latestPrice__AYXu0 .headline_title__x1csO {
    font-size: 14px;
}

.scroll-subtabs_scrollSubInfo__T5nZF {
    flex: 1 1;
    width: 0;
    margin-inline-start: 0;
    position: relative;
}

.scroll-subtabs_tabs__Prom8 {
    flex-flow: row nowrap;
    display: flex;
    /* overflow: hidden; */
    position: relative;
}

.scroll-subtabs_subMarketWrap__XVmHp {
    overflow: auto hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    scrollbar-width: none;
}

.headline_extendInfoWrapper__dooIS,
.headline_left__lBBPY,
.headline_wrapper__BKn9L {
    display: flex;
    align-items: center;
}

.headline_leftItem__7BFYq {
    /* margin-inline-end: 60px; */
    font-size: 10.5px;
    line-height: 20px;
    white-space: nowrap;
}

.headline_withBorder__a6ZD2 {
    border-bottom: 1px dashed transparent;
    opacity: 0.7;
}




.buysell_heder {
    padding: 14px !important;
}

.buysell_heder .custom-tabs {
    padding: 0px 5px;
    width: 100%;
    display: flex;
    position: relative;
    overflow: hidden;
    border-radius: 0px;
    gap: 10px;
    background-color: transparent;
    flex-wrap: nowrap;
}


body.light_theme .buysell_heder .custom-tabs {
    background: #dddddd;
}

body.light_theme .spot_limit button.active {
    border-bottom: 2px solid #696969;
    color: #696969;
}

body.light_theme .actions_balance__kTHO0 {
    color: #000;
}

body.light_theme .buysellform .input-group {
    background: #dddddd;
}

body.light_theme .assets_list ul li {
    color: #000;
}

body.light_theme .assets_list ul li span {
    color: #3a3a3a;
}

body.light_theme .spotLists {
    background: #ececec;
}


body.light_theme .trade_favourites_lft .spot-list-search .ivu-input {
    background: #dddddd;
}

body.light_theme .trade_card {
    background: #ececec;
}

.buysell_heder .custom-tabs li {
    width: 50%;
    position: relative;
}

.status_info {
    display: flex;
    gap: 5px;
}

.status_info input {
    background-color: #999;
    border: 1px solid #666;
    border-radius: 50px;
}

.status_info input {
    background-color: #22242c;
    border: 1px solid #353535;
    border-radius: 50px;
    color: #fff;
    padding: 2px 12px;
    width: 130px;
}

.status_info button {
    border-radius: 50px !important;
}

.buysell_heder .custom-tabs li a {
    width: 100%;
    display: block;
    /* transform: skewX(-20deg); */
    text-align: center;
    padding: 6px 0;
    /* background-color: #ffffff0f; */
    border-radius: 4px;
    font-size: 12px;
    color: currentColor !important;
    transition: unset !important;
}

/* .buysell_heder .custom-tabs li a::before{     width: 16px;
    transform: rotate(-19deg);
    position: absolute;
    left: -6px;
    background-color: #1f1f22;
    height: 110%;
    content: "";
    top: -3px; } */

.buysell_heder .custom-tabs li a.active button {
    background: #5EBA89 !important;
    color: #fff;
}

/* .buysell_heder .custom-tabs li.sell-tab button::before {
    left: inherit;
    background-color: #1f1f22;
    right: -6px;
    top: 0px;
} */

/* .buysell_heder .custom-tabs li.sell-tab a.active::before{ background-color: #ed5765 !important; } */

/* .buysell_heder .custom-tabs li.buysell-tab.buy-tab button {
    border-radius: 4px;
    -ms-transform: skewX(-20deg);
    -webkit-transform: skewX(-20deg);
    transform: skewX(-20deg);
} */

.buysell_heder .custom-tabs.padding-0 li a {
    padding: 0px !important;
}

/* .buysell_heder .custom-tabs li button span {
    -ms-transform: skewX(20deg);
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    display: block;
} */

/* .buysell_two .buysell_heder .custom-tabs li button span {
    -ms-transform: skewX(35deg);
    -webkit-transform: skewX(35deg);
    transform: skewX(35deg);
    display: block;
} */

.actions_balance__kTHO0 {
    margin-bottom: 12px;
    min-height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 300;
}

.midgraph_col {
    position: relative;
}

ul.favorites_list_tabs {
    display: flex;
    gap: 18px;
    align-items: center;
    border-bottom: 1px solid #565656;
    margin: 12px 15px;
}

ul.favorites_list_tabs li button {
    font-size: 14px;
    font-weight: 500;
    color: #949AA4;
    background-color: transparent;
    border-bottom: 2px solid #565656;
    border: none;
    padding: 0px 0px 8px;
}

ul.favorites_list_tabs li button.active {
    color: #fff;
    border-bottom: 2px solid #fff;
}

.midgraph_col .trade_card.trade_chart {
    min-height: 91%;
}

.actions_primaryText__ufKT0 {
    opacity: 0.7;
    margin-right: 10px;
}

body.light_theme.actions_primaryText__ufKT0 {
    opacity: 1;
}

body.light_theme.actions_balance__kTHO0 .text-muted {
    color: #3b3d3e !important;
}

a.actions_deposit__Ydutk {
    color: #01BC8D;
    font-size: 125%;
    margin-left: 10px;
    line-height: 1;
}

.buysellform .form-group label {
    display: block;
    margin-bottom: 4px;
    font-weight: 300;
    font-size: 12px;
    /* opacity: 0.7; */
    color: #F2F4F6;
}

.assets_list ul li span {
    color: #c0c0c0;
}

.process_step {
    position: relative;
}

.process_step:before {
    width: 100%;
    background-color: #393F4F40;
    height: 2px;
    position: absolute;
    content: "";
    left: 0px;
    top: 3px;
}

.process_step label.btn {
    position: relative;
}

.process_step label.btn:before {
    width: 7px;
    background-color: #393F4F40;
    height: 7px;
    position: absolute;
    content: "";
    border-radius: 50px;
    border: 1px solid #393F4F;
    left: 0px;
    top: 1px;
}


.process_step label.btn.checked:before {
    width: 14px;
    background-color: #181a20;
    height: 14px;
    border: 2px solid #F2F4F6;
    top: -3px;
}

.buysell_heder .custom-tabs {
    padding: 5px;
    width: 100%;
    display: flex;
    position: relative;
    overflow: inherit;
    border: none;
    border-radius: 50px;
    gap: 10px;
    background-color: #2B313C;
    flex-wrap: nowrap;
}

.buysell_heder .custom-tabs li button {
    width: 100%;
    display: block;
    /* transform: skewX(-20deg); */
    text-align: center;
    border: none;
    font-weight: 400;
    padding: 6px 10px;
    background-color: #2B313C;
    border-radius: 50px;
    font-size: 14px;
    color: #87909F;
    transition: unset !important;
}

.relative_select_right .buysell_heder .custom-tabs li.active button {
    background-color: #5EBA89 !important;
    border-bottom: none !important;
}

.relative_select_right .buysell_heder .custom-tabs li.selltab.active button {
    background-color: #ed5765 !important;
}

.selltab
/* .buysell_heder .custom-tabs li button::before {
    width: 16px;
    transform: rotate(0deg);
    position: absolute;
    transform: skewX(20deg);
    left: -6px;
    background-color: #1f1f22;
    height: 100%;
    content: "";
    border-radius: 3px;
    top: 0px;
} */


/* .buysell_heder .custom-tabs li.active button::before {
    background: #01BC8D !important;
}

.buysell_heder .custom-tabs li a.active button::before {
    background: #01BC8D !important;
}

.buysell_heder .custom-tabs li button.active::before {
    background: #01BC8D !important;
}

.buysell_heder .custom-tabs li button.selltab::before {
    left: inherit;
    background-color: #1f1f22;
    right: -5px;
    top: 0px;
    border-radius: 3px;
} */

.buysell_heder.padding_space_l {
    padding: 0px !important;
}

.relative_select_right .cnt_table_two {
    display: none;
}

.relative_select_right .cnt_table_two.active {
    display: block;
}

/* .buysell_two .buysell_heder .custom-tabs li button::before {
    width: 28px;
    transform: skewX(35deg);
    left: -11px;
}

.buysell_two .buysell_heder .custom-tabs li.sell-tab button::before {
    left: inherit;
    background-color: #1f1f22;
    right: -10px;
    top: 0px;
} */

.buysell_two .buysell_heder .custom-tabs li.sell-tab a.active button {
    background-color: #ed5765 !important;
}

/* .buysell_heder .custom-tabs li.sell-tab a.active button:before {
    background-color: #ed5765 !important;
}

.buysell_heder .custom-tabs li.selltab button.active::before {
    background-color: #ed5765 !important;
} */


body.light_theme.buysellform .form-group label {
    opacity: 1;
}

.order-btns .btn-mini {
    margin: 5px 0;
    line-height: 1;
    min-height: 36px;
}


.bs_box_header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
}

.bs_box_header h6 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}

.bs_box_header i {
    font-size: 22px;
}



.bs_tab_row {
    position: fixed;
    bottom: 0;
    z-index: 9999;
    width: 100%;
    left: 0;
    padding: 13px;
    border-radius: 0;
    border: 0;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    background: #1e1d3054;
    border-top: 1px solid #2c2c3d8a;
}

body.light_theme.bs_tab_row {
    background: #ffffffc9;
    border-color: #F5F5F5;
}

.bs_tab_row .btn {
    font-weight: 500;
}


.bs_dropbox.spotLists_bs_dropbox {
    display: none;
}

.bs_dropbox.spotLists_bs_dropbox.active {
    display: flex;
}



.spotLists_bs_dropbox {
    position: fixed;
    width: 100%;
    height: 100vh;
    background: #00000075;
    top: 0;
    bottom: 0;
    z-index: 99;
    left: 0;
    align-items: center;
    justify-content: center;

}



@media screen and (max-width: 1100px) and (min-width: 768px) {

    .mmn_btm_minus_spc .col-lg-6 {
        margin: -1px;
    }

    div#tab_3 {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    div#tab_4 {
        margin-top: -17px !important;
        border-radius: 0px 0px 10px 10px;
    }



}



@media screen and (max-width: 767px) and (min-width: 320px) {

    .treade_card_header.tch_main_tab {
        display: flex;
    }

    .headline_bigName__dspVW h1 i {
        display: flex;
    }

    div#tab_3 {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    /* Hide tab_3 on mobile when Chart tab is active */
    div#tab_3.d-none {
        display: none !important;
    }

    div#tab_mobile_trade_history {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    /* Hide mobile Market Trades when Chart tab is active */
    div#tab_mobile_trade_history.d-none {
        display: none !important;
    }

    /* Mobile Market Trades styling */
    div#tab_mobile_trade_history .trade_history_tab {
        padding: 0;
    }

    div#tab_mobile_trade_history .table-responsive {
        max-height: calc(100vh - 400px);
        overflow-y: auto;
    }

    div#tab_mobile_trade_history .price_card_body {
        padding: 0;
    }

    div#tab_4 {
        border-radius: 0px 0px 10px 10px;
    }

    /* Hide mobile Wallets when Chart tab is active */
    div#tab_4_mobile.d-none {
        display: none !important;
    }

    div#tab_4_mobile {
        height: 100%;
        margin-top: 0px;
        border-radius: 0px 0px 10px 10px;
    }

    /* Mobile Wallets styling */
    div#tab_4_mobile .assets_list {
        padding: 0px;
    }

    .assets_btn {
        gap: 10px;
    }

    div#tab_4_mobile .table-responsive {
        max-height: calc(100vh - 400px);
        overflow-y: auto;
    }

    div#tab_4_mobile .price_card_body {
        padding: 0;
    }

    .trade-wrapper.spot.pb-3 .col-12.col-lg-6.col-xl-3.col-xxl-3 {
        margin-top: 7px;
    }


    .mmn_btm_minus_spc .col-lg-6 {
        margin-top: -2px;
    }

    .trade-wrapper {
        padding-top: 10px !important;
        overflow-x: hidden;
    }

    .select_mini {
        font-size: 14px;
        min-width: initial !important;
        height: unset !important;
        padding: 5px 11px !important;
    }


    .container-chart-briefing .spotList {
        background: #22242c;
        left: 0;
        top: 62px;
    }


    .container-chart-briefing {
        height: auto;
        padding: 15px 15px 0;
    }

    .spot-container-main .top {
        flex-direction: column;
    }

    .spot-container {
        flex-direction: column;
    }

    .wm-50 {
        flex: 0 0 auto;
        margin-bottom: 17px;
        width: 50%;
    }

    .container-chart-briefing-info {
        width: 100%;
        justify-content: unset;
        flex-wrap: wrap;
    }

    .container-chart-briefing h2 {
        justify-content: flex-start;
    }

    .spot-container-main .bottom {
        min-height: unset;
        flex-direction: column;
    }

    .bottom-left {
        width: 100%;
        margin-bottom: 20px;
    }

    .bottom-right {
        width: 100%;
    }

    .spot-container-right-right {
        flex: auto;
        max-width: 100%;
    }

    .trade_card {
        padding: 11px 11px;
        padding: 0;
    }

    ul.nav.custom-tabs.order_his_tabs li a {
        padding: 8px 13px;
        font-size: 13px;
        line-height: 1;
    }

    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {
        padding: 3px;
        margin: 0 3px 0 0;
    }

    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {
        background: transparent !important;
    }

}


@media screen and (max-width: 991px) and (min-width: 768px) {


    .spot-container-main .top {
        flex-direction: column;
    }

    .spot-container {
        flex-direction: column;
    }

    .wm-50 {
        flex: 0 0 auto;
        margin-bottom: 17px;
        width: 33.3333333%;
    }

    .container-chart-briefing-info {
        width: 100%;
        justify-content: unset;
        flex-wrap: wrap;
    }

    .container-chart-briefing h2 {
        justify-content: flex-start;
    }

    .spot-container-main .bottom {
        min-height: unset;
        flex-direction: column;
    }

    .bottom-left {
        width: 100%;
        margin-bottom: 20px;
    }

    .bottom-right,
    .spot-container-main .top-right {
        width: 100%;
    }

    .spot-container-right-right {
        flex: auto;
        max-width: 100%;
    }

    ul.nav.custom-tabs.order_his_tabs li a {
        padding: 7px 20px;
        font-size: 14px;
    }

    .container-chart-briefing {
        height: unset;
        padding-bottom: 10px;
    }

    .trade-wrapper.spot {
        max-width: 650px;
        margin-left: auto;
        margin-right: auto;
    }

    .trade-wrapper.spot.pb-3 {
        max-width: 100%;
    }


}


@media screen and (max-width: 1299px) and (min-width: 992px) {

    .spot-container {
        flex-direction: column;
    }

    .spot-container-right-right {
        flex: auto;
        max-width: 100%;
        display: flex;
    }

    /* .inner-page-banner {
            padding: 77px 0 43px;
        } */
    section.pb-90.account_sec {
        padding-bottom: 0;
    }
}

@media screen and (max-width:1550px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 33.6%);
    }

    ul.favorites_list_tabs {
        gap: 12px;
        margin: 12px 7px;
    }

    .trade_card .table> :not(caption)>*>* {
        font-size: 11px;
    }

    .trade-wrapper .orderbook-table th {
        padding: 4px 7px;
    }

    .trade-wrapper .orderbook-table td {
        padding: 4px 7px;
    }

    ul.favorites_list_tabs li button {
        font-size: 13px;
    }

}

@media screen and (max-width:1440px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 237px);
    }

    .assets_btn {
        gap: 10px;
    }

    .trade-wrapper .orderbook-table th {
        font-size: 10px !important;
        padding: 4px 5px;
    }

    .trade-wrapper .orderbook-table td {
        font-size: 10px !important;
        padding: 4px 5px !important;
    }

    .card_header_title {
        font-size: 12px;
    }

    ul.favorites_list_tabs li button {
        font-size: 12px;
        padding: 0px 0px 5px;
    }

    ul.favorites_list_tabs {
        gap: 10px;
        margin: 5px 5px;
    }

    .assets_btn button {
        font-size: 12px;
        padding: 5px 5px;
    }

}

@media screen and (max-width:1367px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 226px);
    }

    .trade_favourites_lft .spotLists {
        height: 100%;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        width: 98.5%;
    }

    div#tab_3 {
        border-radius: 0px;
    }


}


@media screen and (max-width: 1200px) {

    .trade_card.p-2.overflow_card.mb-1 {
        width: calc(100% + 0px);
    }

    .midgraph_col {
        width: 70%;
    }

    .trade_favourites_lft {
        width: 30%;
    }

    .trade-wrapper .row {
        row-gap: 24px;
    }

    div#tab_3 {
        border-radius: 0px;
    }

    div#tab_4 {
        border-radius: 10px;
        margin-top: 0px !important;
    }

}

/* Ensure tab_3 shows on desktop (lg+) even if d-none is present */
@media screen and (min-width: 992px) {
    div#tab_3.d-none.d-lg-block {
        display: block !important;
    }
}

@media screen and (max-width: 991px) {

    .midgraph_col {
        width: 60%;
    }

    .trade_favourites_lft {
        width: 40%;
    }

    .bs_tab_row {
        z-index: 999999;
    }

    .mmn_btm_minus_spc button.btn.btn-danger {
        font-size: 12px;
        padding: 6px 16px;
    }

    .bs_tab_row button.btn.btn-success {
        padding: 6px 16px;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        left: 1px;
    }

}


@media screen and (max-width: 1600px) and (min-width: 1200px) {
    .spot-container .col-xxl-2 {
        flex: 0 0 auto;
        width: 24%;
    }

    .spot-container .col-xxl-4 {
        flex: 0 0 auto;
        width: 48%;
    }

    .spot-container .col-xxl-8 {
        flex: 0 0 auto;
        width: 52%;
    }
}

@media screen and (max-width: 3000px) and (min-width: 1601px) {
    .spot-container .col-xxl-2 {
        flex: 0 0 auto;
        width: 20%;
    }

    .spot-container .col-xxl-4 {
        flex: 0 0 auto;
        width: 40%;
    }

    .spot-container .col-xxl-8 {
        flex: 0 0 auto;
        width: 60%;
    }
}

.scroll_y_reverse {
    display: flex;
    flex-direction: column-reverse;
}


.font-weight-boldd {
    font-weight: 600;
}




/* responsive */
@media (max-width: 767px) {

    /* Mobile Favourites Toggle Button */
    .mobile-favourites-toggle-btn {
        display: block;
        margin-bottom: 15px;
    }

    .favourites-toggle-btn-mobile {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        background-color: #2B313C;
        border: 1px solid #434343;
        border-radius: 8px;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .favourites-toggle-btn-mobile:hover {
        background-color: #373E4B;
        border-color: #565A62;
    }

    .favourites-toggle-btn-mobile:focus-visible {
        background-color: #373E4B;
        border-color: #565A62;
    }

    .favourites-toggle-btn-mobile:active {
        background-color: #373E4B !important;
        border-color: #565A62 !important;
    }

    .favourites-toggle-btn-mobile i {
        font-size: 16px;
    }

    body.light_theme.favourites-toggle-btn-mobile {
        background-color: #f5f5f5;
        border-color: #e0e0e0;
        color: #333;
    }

    body.light_theme.favourites-toggle-btn-mobile:hover {
        background-color: #e9e9e9;
        border-color: #d0d0d0;
    }

    .trade_favourites_lft.hide-favourites-mobile {
        display: none;
    }

    .trade_favourites_lft.show-favourites-mobile {
        display: block;
    }

    .midgraph_col {
        width: 100%;
    }

    .trade_favourites_lft {
        width: 100%;
        display: none;
    }

    /* Mobile Favourites Popup */
    .mobile-favourites-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 999999;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0);
        }
    }

    .mobile-favourites-popup {
        width: 100%;
        max-height: 85vh;
        background-color: #2b313c;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        display: flex;
        flex-direction: column;
        animation: slideUp 0.3s ease;
        overflow: hidden;
        border-radius:10px 10px 0px 0px;
    }

    .mobile-favourites-popup .orderbook-table th {
        background: #2b313c;
    }

    .headline_bigName__dspVW h1 {
        display: flex;
    }

    body.light_theme.mobile-favourites-popup {
        background-color: #ffffff;
    }

    .mobile-favourites-popup-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 15px 5px;
        border-bottom: none;
    }

    body.light_theme.mobile-favourites-popup-header {
        border-bottom-color: #e0e0e0;
    }

    .mobile-favourites-popup-header h4 {
        margin: 0;
        font-size: 15px;
        font-weight: 400;
        color: #fff;
    }

    body.light_theme.mobile-favourites-popup-header h4 {
        color: #333;
    }

    .mobile-favourites-close-btn {
        background: transparent;
        border: none;
        color: #9b9b9b;
        font-size: 22px;
        cursor: pointer;
        padding: 5px;
        font-weight: 300;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        transition: background-color 0.2s ease;
    }

    .mobile-favourites-close-btn:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    body.light_theme.mobile-favourites-close-btn {
        color: #333;
    }

    body.light_theme.mobile-favourites-close-btn:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }

    .mobile-favourites-popup-content {
        flex: 1 1;
        overflow-y: auto;
    }

    .mobile-favourites-popup-content .spotLists {
        background: transparent;
        padding: 0;
        display: block;
        top: 0px;
        max-width: calc(100% - 0px);
        left: 0px;
    }

    .mobile-favourites-popup-content ul.favorites_list_tabs {
        padding: 0px 10px;
    }

    .mobile-favourites-popup-content img.round_img {
        width: 18px !important;
        height: 18px !important;
    }

    .orderbook-table td {
        padding: 4px 7px;
    }

    ul.favorites_list_tabs li button {
        font-size: 12px;
    }

    ul.favorites_list_tabs {
        gap: 15px;
        margin: 7px 0px;
    }

    .headline_left__lBBPY_leftmain.d-flex.align-items-center {
        width: 50%;
    }

    .scroll-subtabs_subMarketWrap__XVmHp {
        /* max-width: 264px; */
        min-width: 194px;
    }

    .mmn_btm_minus_spc {
        margin-bottom: -.5rem;
    }

    .tch_main_tab .card_header_title {
        height: 32px;
        line-height: 32px;
        padding: 1px 7px;
    }

    .trade_summary_table_lft {
        padding: 10px !important;
    }

    .trade-wrapper.spot {
        padding-top: 3px !important;
    }

    .infor_row li {
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        padding: 5px 0;
    }

    .inf_row {
        padding: 1rem;
        height: 429px !important;
        overflow-y: auto;
    }



    .scroll-subtabs_scrollSubInfo__T5nZF {
        flex: 1 1;
        width: 0;
        margin-inline-start: 0;
        position: relative;
    }

    .headline_left__lBBPY_leftmain.d-flex.align-items-center {
        flex-direction: column;
        align-items: flex-start !important;
        justify-content: flex-start;
    }

    .headline_left__lBBPY_leftmain .headline_symbolName__KfmIZ {
        margin-bottom: 0;
    }

    /* .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {
        flex-direction: column;
        align-items: flex-start !important;
    } */

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 5px;
        align-items: flex-start !important;
    }

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq {
        display: flex;
        width: 100%;
        justify-content: flex-end;
    }

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_withBorder__a6ZD2 {
        flex: 1 1;
        font-size: 9px;
        text-align: start;
        margin-inline-end: 0;
    }

    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_title__x1csO {
        flex: 1 1;
        text-align: right;
        margin-inline-end: 0;
    }

    .headline_latestPrice__AYXu0 .headline_title__x1csO {
        font-size: 16px;
    }

    .trade-wrapper .assets_list h4 {
        font-size: 14px;
        align-items: center;
        gap: 5px;
        display: flex;
    }

    .inf_row .headline_bigName__dspVW,
    .headline_bigName__dspVW h1 {
        font-size: 14px !important;
    }

    span.headline_change__tGyxo {
        font-size: 16px;
    }

    .headline_leftItem__7BFYq {
        /* margin-inline-end: 60px; */
        font-size: 12px;
        line-height: 1.2;
        white-space: nowrap;
        padding: 4px 0;
        font-weight: normal;
    }

    .headline_leftItem__7BFYq {
        margin-inline-start: 0;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 3px;
    }

    .scroll-container {
        overflow-y: auto;
        max-height: 175px;
        height: auto;
    }

    .exchange_chartContent__Ijukg {
        height: auto;
        overflow-y: auto;
    }

    .information_bright__F_RTd {
        opacity: 1 !important;
        margin-left: 6px;
    }

    .information_left__vgFSY,
    .information_right__kqyPI {
        width: 41%;
    }

    .trade-wrapper .btn {
        height: auto !important;
        min-height: unset !important;
        margin-top: 5px;
        border-radius: 50px;
    }

    .btn-group.btn-group-mini {
        margin-bottom: 3px;
    }

    .btn-group.btn-group-mini * {
        padding: 0px 0px;
        min-height: unset;
        border-radius: 9px !important;
        line-height: 29px;
        font-size: 11px !important;
    }

    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-2,
    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-3.order-xl-3 {
        margin-top: 0;
    }

    .price_card_body.price_card_body_full,
    .scroll_y {
        height: 240px;
    }

    .scroll_y_full {
        height: 502.8px;
    }

    .scroll_y_full {
        /* height: 480px; */
    }

    .scroll_y_coins {
        height: 339px;
    }

    footer.footer-wrapper {
        margin-top: 0;
    }



    .trade-wrapper .container-fluid {
        padding-right: 8px;
        padding-left: 8px;
        overflow: hidden;
    }

    .scroll-subtabs_tabs__Prom8 {
        justify-content: flex-end;
    }


    .trade_tabs .num-select {
        font-size: 10px;
    }

    .buysell_heder {
        padding: 10px !important;
    }

    .spot .form-control,
    .spot select {
        padding: 7px 18px;
        min-width: unset;
    }

    .trade_chart .form-select-sm {
        padding: 6px 9px !important;
        font-size: 12px;
    }

    .actions_balance__kTHO0 {
        flex-direction: column;
        align-items: start;
        line-height: 1.5;
    }

    .actions_primaryText__ufKT0 {
        opacity: 0.7;
        margin-right: 10px;
        font-size: 10px;
        margin-bottom: 3px;
    }

    .trade-wrapper .mb-1 {
        margin-bottom: 4px !important;
    }

    .price_card_head>div {
        word-break: break-all;
        font-size: 10px;
        vertical-align: bottom;
        padding: 0 6px;
    }

    .price_card .price_card_head {
        padding: 0 5px;
        margin: 0;
        min-height: 24px;
        line-height: 1.1;
    }

    .trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {
        padding: 0px 7px 0px 9px;
    }

    .price_item_value span:first-child,
    .price_card_head>div:first-child {
        padding-left: 5px;
    }

    body .trade_card#tab_mobile_trade_history .table> :not(caption)>*>* {
        padding: 5px !important;
    }

    .price_item_value span {
        word-break: break-all;
        white-space: nowrap;
        line-height: 1.1;
    }

    .buysellform .input-group {
        padding: 0px 11px;
    }

    .buysell_card {
        /* height: 504px; */
    }

    .price_item_value span:last-child,
    .price_card_head>div:last-child {
        padding-right: 5px;
    }

    .buy_sell_row_price .scroll_y {
        height: 400px;
    }

    .usd_future_dashboard .table_info_data table tr td {
        font-size: 10px;
    }

    .usd_future_dashboard .table_info_data table tr th {
        font-size: 10px;
    }

    .buy_sell_row_price #buy_orders .scroll_y,
    .buy_sell_row_price #sell_orders .scroll_y {
        height: 400px;
    }

    .spotLists {
        width: 100%;
        max-width: calc(100% - 12px);
        left: 6px;
        top: 162px;
        min-height: 468px;
    }

    .bs_dropbox .spotLists {
        width: 100%;
        width: 100%;
        max-width: 500px;
        top: unset;
        left: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .spotLists .price_card_body.tab-content.scroll_y {
        height: 345px;
    }

}

@media screen and (max-width: 660px) {

    .headline_leftItem__7BFYq {
        font-size: 11px;
    }
}

@media screen and (max-width: 991px) and (min-width: 320px) {

    /* .bs_dropbox .summay_dasboard_pop {
        display: block !important;
    } */

    .bs_dropbox .trade_card.trade_chart.buysell_card {
        width: 100%;
        min-height: 100%;
    }

    div#tab_4 {
        margin-top: -0.5rem;
    }

    .bs_dropbox .col-lg-6 {
        padding: 0px;
    }

    .summay_dasboard_pop {
        height: auto !important;
        width: 40%;
        border-radius: 0px !important;
    }


    .bs_dropbox {
        position: fixed;
        width: 100%;
        background: #000000d6;
        top: 0;
        bottom: 0;
        z-index: 999999;
        left: 0;
        display: flex;
        align-items: end;
        justify-content: center;
        min-width: 100%;
        max-width: 100%;
    }

    .trade-wrapper .bs_dropbox .row {
        width: 100%;
    }

    .bs_dropbox .buysell_card {
        height: auto;
        width: 100%;
        max-width: 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        overflow-y: auto;
        max-height: 100%;
        background-color: #111114;
    }

    .bs_dropbox .summay_dasboard_pop {
        padding: 0px 3px;
    }

    .bs_dropbox .price_card_head>div {
        font-size: 8px;
    }

    .bottm_lightbox_two {
        height: 80vh;
    }

    .bottm_lightbox_two .trade_card,
    .spotLists {
        border: none;
        border-radius: 0px;
    }

    .bottm_lightbox_two .assets_btn {
        flex-direction: row;
    }

    .bottm_lightbox_two .assets_list {
        margin: 10px 20px 20px;
    }

    .bs_dropbox .buysell_card .btn-mini {
        font-size: 12px !important;
        padding: 10px 10px 9px;
    }

    .bs_dropbox .bs_box_header {
        margin-bottom: 3px;
    }

    .bs_dropbox .spot_limit select {
        background: transparent !important;
        box-shadow: none;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        border: none;
        padding: 0px;
        min-width: unset;
        border-radius: 0px !important;
    }

    .bs_dropbox .buysell_card .p-2.p-md-3 {
        padding: 15px !important;
    }

    .bs_dropbox .price_card_body.scroll_y.scroll_y_reverse {
        align-items: normal;
        justify-content: start;
        max-height: 100%;
        min-height: 100%;
        height: 100%;
    }

    .bs_dropbox .buysell_heder .custom-tabs li.buysell-tab.buy-tab a {
        border-radius: 0px;
    }

    .bs_dropbox .buysell_heder .custom-tabs li a {
        border-radius: 0px;
    }

    .bs_dropbox .trade_card.trade_chart.buysell_card .assets_list {
        margin: 0px 15px 15px;
    }


    .bs_dropbox .buysellform .input-group .form-control {
        font-size: 11px !important;
        padding: 3px 6px;
    }

    .bs_dropbox .price_card_body.scroll_y {
        max-height: 39%;
        min-height: 39%;
        overflow: auto;
    }

    .bs_dropbox .buysell_card.trade_chart .form-select-sm {
        padding: 0px !important;
        font-size: 11px;
    }

    .bs_dropbox .buysellform .input-group {
        padding: 7px 7px 7px 3px;
    }

    .bs_dropbox .btn-group.btn-group-mini * {
        font-size: 10px !important;
    }

    .bs_dropbox .assets_list h4 {
        font-size: 15px;
    }

    .bs_dropbox a.more_btn {
        font-size: 11px;
    }

    .bs_dropbox .assets_list .top_heading {
        flex-direction: row;
    }

    .bs_dropbox .buysell_heder {
        padding: 13px 15px !important;
    }

    .bs_dropbox .buysell_heder .custom-tabs li a {
        padding: 4px 0;
        font-size: 12px;
        font-weight: 600;
    }


    .headline_extendInfoWrapper__dooIS,
    .headline_left__lBBPY,
    .headline_wrapper__BKn9L {
        display: flex;
        align-items: start;
    }

    .bs_dropbox.active {
        display: flex !important;
    }
}

@media (max-width: 480px) {

    #tab_1 {
        height: 400px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TradePage/trade_new.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;;AAGA;;IAEI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;AAEJ;;;AAGA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,iEAAiE;AACjE;IACI,aAAa;AACjB;;AAEA,wDAAwD;AACxD;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAO;AACX;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;;;;AAKA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;AAGA;;IAEI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;;;AAIA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;+EAC2E;IAC3E,kBAAkB;IAClB,gBAAgB;AACpB;;;AAGA;;IAEI,yBAAyB;IACzB,2BAA2B;IAC3B,iEAAiE;AACrE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;;;AAKA;IACI,WAAW;IACX,aAAa;AACjB;;;AAGA,aAAa;;AAEb;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,qCAAqC;AACzC;;;AAGA;;IAEI,UAAU;IACV,6BAA6B;AACjC;;AAEA;;IAEI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,iCAAiC;IACjC,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2BG;;;AAGH;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,UAAU;IACV,2BAA2B;IAC3B,kCAAkC;IAClC,WAAW;IACX,yCAAiC;YAAjC,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,wDAAwD;IACxD,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;;GAGG;;AAEH;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;IAC1B,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,sEAAsE;IACtE,6BAA6B;IAC7B,qBAAqB;IACrB,cAAc;IACd,mCAA2B;YAA3B,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,SAAS;IACT,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,+BAA+B;IAC/B;+EAC2E;IAC3E,qBAAqB;IACrB,UAAU;AACd;;AAEA,6GAA6G;;AAE7G;IACI,kCAAkC;IAClC,kCAAkC;IAClC,2DAA2D;IAC3D,WAAW;AACf;;;AAGA;;;;;IAKI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,0DAA0D;;AAE1D,0DAA0D;;AAE1D;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;;IAGI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;;;IAII,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,8CAA8C;IAC9C,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,gCAAgC;IAChC,uBAAuB;AAC3B;;;;;AAKA;;;;;KAKK;;;AAGL;;IAEI,kDAAkD;IAClD,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,iDAAiD;IACjD,4BAA4B;AAChC;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;;IAEjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;;IAEI,wCAAwC;AAC5C;;;AAGA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,mCAAmC;IACnC,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,MAAM;IACN,UAAU;IACV,oCAAoC;AACxC;;;AAGA;IACI,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,iBAAiB;IACjB,iCAAiC;IACjC,SAAO;AACX;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;;;;;AAMA;;;;;;;;;;;;;;;;;GAiBG;;AAEH;IACI,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,yCAAyC;IACzC,UAAU;IACV,mCAAmC;IACnC,2BAA2B;IAC3B,gBAAgB;AACpB;;;AAGA;;IAEI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;;AAGA;IACI,mBAAmB;IACnB,yCAAyC;AAC7C;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,YAAY;AAChB;;;AAGA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,eAAe;IACf,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;;;;AAKA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,iEAAiE;AACrE;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,4BAA4B;IAC5B,yCAAiC;YAAjC,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,SAAS;IACT,4BAA4B;IAC5B,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,cAAc;AAClB;;;AAGA;IACI,2BAAsB;IAAtB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,QAAQ;AACZ;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,eAAe;AACnB;;;AAGA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;IAII;AACJ;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,2BAA2B;IAC3B,iCAAiC;IACjC,iBAAiB;IACjB,mCAAmC;IACnC,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,kBAAkB;;AAElB;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB,EAAE;;AAEvB;QACQ,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;IACvB;;AAEJ;IACI,sBAAsB;IACtB,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,sCAAsC;IACtC,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IAEnB,sBAAsB;AAC1B;;AAEA;;IAEI,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;;;AAIA,eAAe;;AAEf;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,yBAAyB;IAC7B;;AAEJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;;;;AAKA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,6BAA6B;IAC7B,iBAAiB;AACrB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;;;;;;;kBAOkB;;AAElB;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;;;;;GAKG;;AAEH,sGAAsG;;AAEtG;;;;;GAKG;;AAEH;IACI,uBAAuB;AAC3B;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;IAChC,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,QAAQ;AACZ;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAoCI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;;;;;;;;GAWG;;AAEH;IACI,oCAAoC;AACxC;;AAEA;;;;;;GAMG;;;AAGH;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;AACnB;;;;AAIA;IACI,eAAe;IACf,SAAS;IACT,aAAa;IACb,WAAW;IACX,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mCAAmC;IACnC,2BAA2B;IAC3B,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;;AAIA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,MAAM;IACN,SAAS;IACT,WAAW;IACX,OAAO;IACP,mBAAmB;IACnB,uBAAuB;;AAE3B;;;;AAIA;;IAEI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA;QACI,4BAA4B;QAC5B,gCAAgC;IACpC;;;;AAIJ;;;;AAIA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA,kDAAkD;IAClD;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA,uDAAuD;IACvD;QACI,wBAAwB;IAC5B;;IAEA,iCAAiC;IACjC;QACI,UAAU;IACd;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,gCAAgC;IACpC;;IAEA,iDAAiD;IACjD;QACI,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,gCAAgC;IACpC;;IAEA,2BAA2B;IAC3B;QACI,YAAY;IAChB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;QAC5B,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,6BAA6B;QAC7B,wBAAwB;QACxB,4BAA4B;IAChC;;;IAGA;QACI,mBAAmB;QACnB,OAAO;QACP,SAAS;IACb;;;IAGA;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,kCAAkC;IACtC;;AAEJ;;;AAGA;;;IAGI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;;AAGJ;;;AAGA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,aAAa;IACjB;;IAEA;;WAEO;IACP;QACI,iBAAiB;IACrB;AACJ;;AAEA;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;AAEJ;;AAEA;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;;AAGJ;;;AAGA;;IAEI;QACI,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,0BAA0B;IAC9B;;AAEJ;;AAEA,kEAAkE;AAClE;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;AAEJ;;;AAGA;IACI;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;;IAEA;QACI,cAAc;QACd,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,gBAAgB;AACpB;;;;;AAKA,eAAe;AACf;;IAEI,oCAAoC;IACpC;QACI,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,oCAAoC;QACpC,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,yBAAyB;QACzB,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA,4BAA4B;IAC5B;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,oCAAoC;QACpC,eAAe;QACf,aAAa;QACb,qBAAqB;QACrB,uBAAuB;QACvB,2BAA2B;IAC/B;;IAEA;QACI;YACI,UAAU;QACd;;QAEA;YACI,UAAU;QACd;IACJ;;IAEA;QACI;YACI,2BAA2B;QAC/B;;QAEA;YACI,wBAAwB;QAC5B;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,yBAAyB;QACzB,2BAA2B;QAC3B,4BAA4B;QAC5B,aAAa;QACb,sBAAsB;QACtB,4BAA4B;QAC5B,gBAAgB;QAChB,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,SAAS;QACT,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,cAAc;QACd,eAAe;QACf,eAAe;QACf,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,sCAAsC;IAC1C;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,UAAU;QACV,cAAc;QACd,QAAQ;QACR,2BAA2B;QAC3B,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,wBAAwB;QACxB,gBAAgB;IACpB;;;;IAIA;QACI,SAAS;QACT,QAAQ;QACR,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,kCAAkC;QAClC,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;OAGG;;IAEH;QACI,aAAa;QACb,8BAA8B;QAC9B,QAAQ;QACR,kCAAkC;IACtC;;IAEA;QACI,aAAa;QACb,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,SAAS;QACT,cAAc;QACd,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,iBAAiB;QAEjB,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,QAAQ;QACR,aAAa;IACjB;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,gBAAgB;IACpB;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,uBAAuB;QACvB,4BAA4B;QAC5B,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,6BAA6B;QAC7B,iBAAiB;QACjB,0BAA0B;IAC9B;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;;;IAIA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;;IAGA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;QAC3B,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,SAAS;QACT,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;QACrB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,4BAA4B;QAC5B,SAAS;QACT,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV,OAAO;QACP,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;OAEG;;IAEH;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,UAAU;QACV,6BAA6B;IACjC;;;IAGA;QACI,eAAe;QACf,WAAW;QACX,qBAAqB;QACrB,MAAM;QACN,SAAS;QACT,eAAe;QACf,OAAO;QACP,aAAa;QACb,gBAAgB;QAChB,uBAAuB;QACvB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,4BAA4B;QAC5B,6BAA6B;QAC7B,gBAAgB;QAChB,gBAAgB;QAChB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;;IAEA;;QAEI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kCAAkC;QAClC,gBAAgB;QAChB,mCAAmC;QACnC,2BAA2B;QAC3B,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;;IAGA;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;;;IAGA;;;QAGI,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".spot-container {\n    color: var(--white-color);\n}\n\n\n@media (min-width: 1920px) {\n\n    .trade_body .fluid-header {\n        padding: 4px 0;\n    }\n}\n\n@media (max-width: 1499px) {\n    .trade_body .fluid-header {\n        padding: 5px 15px;\n    }\n\n}\n\n\n.price_item_value .td_div img {\n    width: 20px;\n    margin-right: 5px !important;\n}\n\n.trade-wrapper {\n    padding-top: 10px !important;\n}\n\n/* Mobile Favourites Popup - Hidden by default (desktop/tablet) */\n.mobile-favourites-popup-overlay {\n    display: none;\n}\n\n/* Mobile Favourites Toggle Button - Hidden by default */\n.mobile-favourites-toggle-btn {\n    display: none;\n}\n\n\n.spot-container-main {\n    display: flex;\n    flex-direction: column;\n    /*padding: 0 15px;*/\n    flex: 1;\n}\n\n.spot-container-main .top {\n    display: flex;\n}\n\n.trade_row {\n    margin: 0 0;\n}\n\n.trade_col {\n    padding: 0 5px;\n    width: 100%;\n}\n\n\n\n\n.spot-container-main .top-left {\n    flex-grow: 1;\n}\n\n.spot-container-main .top-right {\n    width: 380px;\n}\n\n\ndiv#TVChartContainer,\ndiv#TVChartContainer * {\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.container-chart-briefing {\n    height: 80px;\n    position: relative;\n    justify-content: flex-start;\n    width: 100%;\n    padding: 20px;\n    display: flex;\n    align-items: center;\n}\n\n\n\n.text-danger {\n    color: #E45561 !important;\n}\n\n.trade_card,\n.spotLists {\n    background: #181A20;\n    border: none;\n    border-radius: 0px;\n    overflow: hidden;\n    /* backdrop-filter removed: background is opaque so the blur is invisible\n       but still forces a GPU re-blur every scroll frame (scroll-jank source) */\n    position: relative;\n    color: #fffffff2;\n}\n\n\nbody.light_theme.trade_card,\nbody.light_theme.spotLists {\n    background-color: #ffffff;\n    border: 1px solid #7878781a;\n    /* backdrop-filter removed: opaque background, blur not visible */\n}\n\n.container-chart-briefing-info {\n    font-size: 12px;\n    text-align: left;\n    display: flex;\n    flex-grow: 1;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\ndd,\ndl,\ndt {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: block;\n    line-height: 1.5;\n    font-weight: 500;\n}\n\n.container-chart-briefing h2 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    padding-right: 20px;\n    cursor: pointer;\n    font-weight: 700;\n    color: #ffffff;\n}\n\n.container-chart-briefing-info dd.big,\n.container-chart-briefing-info dt.big {\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.container-chart-briefing-info dd.green,\n.container-chart-briefing-info dt.green {\n    color: #01BC8D !important;\n}\n\n.container-chart-briefing .displayName>span {\n    padding-right: 10px;\n}\n\n\n.trade-wrapper .btn {\n    justify-content: center;\n}\n\ndd {\n    font-weight: 600;\n}\n\n\n\n\n.tv-chart {\n    width: 100%;\n    height: 507px;\n}\n\n\n/*order book*/\n\n.card_title {\n    font-size: 16px;\n    font-weight: 600;\n    text-align: center;\n    padding-bottom: 1rem;\n    color: currentColor;\n}\n\n\n.trade_tabs {\n    padding: 10px;\n}\n\n.trade_card_body.single-widget ul li a {\n    font-size: 14PX;\n}\n\n.price_card_head {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    font-family: \"Roboto\", sans-serif;\n    line-height: 12px;\n    justify-content: space-between;\n    height: 24px;\n    color: #87909F;\n    line-height: 24px;\n    /* border-bottom: 1px solid #2b2f39 */\n}\n\n\n.price_card_body::-webkit-scrollbar,\n.scroll_y::-webkit-scrollbar {\n    width: 3px;\n    background-color: transparent;\n}\n\n.price_card_body::-webkit-scrollbar-thumb,\n.scroll_y::-webkit-scrollbar-thumb {\n    border-radius: 3px;\n    background: rgb(106 106 106 / 21%);\n}\n\n.price_item_value {\n    display: flex;\n    position: relative;\n    z-index: 1;\n    color: #F2F4F6;\n    font-family: \"Roboto\", sans-serif;\n    width: 100%;\n    padding: 2px 0;\n    justify-content: space-between;\n    font-weight: 400;\n    align-items: center;\n}\n\n.price_item_value:hover {\n    background: #ffffff14;\n}\n\nbody.light_theme.trade-wrapper {\n    background-color: #f5f5f55e;\n}\n\nbody.light_theme.price_item_value {\n    /* border-bottom: 1px solid rgb(0 0 0 / 5%); */\n    border-color: #58585814;\n}\n\n.price_item_value span {\n    display: block;\n    /*color: #ffffff;*/\n    font-size: 11px;\n}\n\n/* \n.price_item_value span.text-green,\n.price_item_value span.text-danger {\n    font-weight: 400;\n}\n\n.price_item_value span:first-child,\n.price_card_head>div:first-child {\n    display: block;\n    width: 33.33333%;\n    padding-left: 10px;\n}\n\n.price_item_value span:nth-child(2),\n.price_card_head>div:nth-child(2) {\n    display: block;\n    width: 33.33333%;\n    text-align: center;\n}\n\n.price_item_value span:last-child,\n.price_card_head>div:last-child {\n    display: block;\n    width: 33.33333%;\n    text-align: right;\n    padding-right: 10px;\n    font-weight: 500;\n} */\n\n\n.price_item_value:last-child {\n    /* border: 0; */\n}\n\n.live_ppc {\n    font-weight: 500;\n    padding: 1rem 0;\n    line-height: 1;\n}\n\n.price_card_body.price_card_body_full,\n.scroll_y {\n    height: 450px;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.buy_sell_row_price .scroll_y {\n    height: 230px;\n}\n\n.buy_sell_row_price #buy_orders .scroll_y,\n.buy_sell_row_price #sell_orders .scroll_y {\n    height: 520px;\n}\n\n.buysell_card {\n    /* height: 533px; */\n}\n\n.spot-container-right-right {\n    flex: 0 0 300px;\n    max-width: 300px;\n}\n\n.scroll_y_mt {\n    height: 322px;\n}\n\ndiv#tab_3 {\n    height: 91%;\n    margin-top: 63px;\n}\n\n.trade_card.p-2.overflow_card.mb-1 {\n    width: calc(100% + 33.50%);\n}\n\n.order-4 {\n    margin: 0;\n}\n\n\n.assets_list {\n    /* width: 100%; */\n    margin: 57px 21px 20px;\n    position: relative;\n    z-index: 666;\n}\n\n.trade_card.trade_chart.buysell_card .assets_list {\n    margin: 0px 21px 20px;\n}\n\n.assets_list ul {\n    font-size: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    justify-content: space-between;\n    align-items: center;\n    color: #fff;\n}\n\n.assets_list ul li {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.assets_btn {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    margin: 20px 0px;\n}\n\n.assets_btn button {\n    width: 100%;\n    background-color: #2B313C;\n    color: #F2F4F6;\n    border: none;\n    font-size: 14px;\n    padding: 7px 16px;\n    border-radius: 50px;\n}\n\n.assets_list h4 {\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.assets_list .top_heading {\n    margin-bottom: 10px;\n}\n\n.assets_list .more_btn {\n    margin: 0px;\n}\n\n\n.trade_chart .form-select-sm {\n    padding: 9px 10px !important;\n    font-size: 12px;\n    background: #22242c;\n    border-radius: 4px !important;\n    border-color: #2d303a00;\n    box-shadow: none;\n    color: #F2F4F6;\n}\n\n.buysellform>p {\n    margin: 7px 0 11px;\n    font-size: 14px;\n}\n\n.btn-mini {\n    font-size: 13px !important;\n    padding: 7px;\n    font-weight: 600;\n}\n\n.buy_sell_cards ul.nav.custom-tabs {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: \"Roboto\", sans-serif;\n    padding: 0;\n    box-shadow: none !important;\n    background: transparent !important;\n    width: 100%;\n    backdrop-filter: unset !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs.nav_order li {\n    /* max-width: fit-content; */\n    flex: 1 1 auto;\n    text-align: center;\n}\n\n\n.buy_sell_cards ul.nav.custom-tabs li a {\n    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */\n    display: block;\n    text-align: center;\n    border-radius: 40px;\n    padding: 4px 6px;\n    color: #fff;\n    background-color: #ffffff1a !important;\n    font-size: 13px;\n    font-weight: 500;\n    margin: 0 3px;\n}\n\n.buy_sell_cards ul.nav.custom-tabs li a.active {\n    color: #000 !important;\n    background-color: #fea903 !important;\n    opacity: 1 !important;\n}\n\n.buy_sell_cards ul.nav.custom-tabs li a.active {\n    color: #e9e9e9 !important;\n}\n\nbody.light_theme.buy_sell_cards ul.nav.custom-tabs li a {\n    background-color: #f1f4f4;\n    color: rgba(0, 0, 0, 0.75);\n}\n\n.custom-tabs li.buy-tab a:hover {\n    color: rgba(255, 255, 255, 0.75);\n    /*background-color: var(--bs-green)54;*/\n}\n\n.custom-tabs li.sell-tab a:hover {\n    color: rgba(255, 255, 255, 0.75);\n    /*background-color: #fe535b2b;*/\n}\n\n.custom-tabs li.buysell-tab a {\n    cursor: pointer;\n}\n\n.buysell_heder .custom-tabs li a {\n    cursor: pointer;\n}\n\n/* .custom-tabs li.sell-tab a.active,\n.custom-tabs li.sell-tab a:active {\n    color: #fff !important;\n    background-color: #ed5765 !important;\n} */\n\nbutton.btn.btn-danger {\n    color: #fff !important;\n    background-color: #E45561 !important;\n}\n\n/* .custom-tabs li.buysell-tab a.active {\n    color: #fff !important;\n    background: #01BC8D !important;\n} */\n\n.text-green {\n    color: #01BC8D;\n}\n\n.spot-deal-warp {\n    margin-top: 25px;\n}\n\n.custom-tabs {\n    color: var(--white-color);\n    background: #ffffff1c;\n    backdrop-filter: blur(3px);\n    -webkit-backdrop-filter: blur(3px);\n    padding: 4px;\n    font-size: 16px;\n    font-weight: 500;\n    border-radius: 50px;\n    display: inline-flex;\n}\n\n.headline_bigName__dspVW h1 i {\n    display: none;\n}\n\n.spot .input-group {\n    background: transparent;\n    border-radius: 40px;\n    overflow: hidden;\n    /* box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px; */\n}\n\n.spot .input-group>span {\n    text-align: center !important;\n}\n\n.spot .input-group>span small {\n    text-align: center;\n    margin: 0 auto;\n}\n\n.input-group-text {\n    /*background-color: #20202d0d;*/\n    /* border: 1px solid #20202d; */\n    border-radius: 0;\n    color: currentColor;\n    line-height: 1.2;\n    min-width: 76px;\n    font-weight: 500;\n    border: 0;\n    background: transparent;\n}\n\n.input-group-text small {\n    font-size: 75%;\n}\n\n.spot .form-control,\n.spot select {\n    color: currentColor;\n    background-color: #2f2f39;\n    border: 0;\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    border-radius: 3px !important;\n    background: #ffffff17;\n    color: #ffffff;\n    backdrop-filter: blur(10px);\n    border: 1px solid #ffffff1c;\n    padding: 7px 18px;\n    min-width: unset;\n    border-radius: 50px !important;\n}\n\nbody.light_theme.spot .form-control {\n    background-color: transparent;\n}\n\n.form-control:focus {\n    box-shadow: none;\n}\n\n.btn-group.btn-group-mini {\n    width: 100%;\n    border-radius: 0 !important;\n    border: 0;\n    background: transparent;\n    margin-left: auto !important;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 5px;\n}\n\n.btn-group.btn-group-mini * {\n    border-block: none;\n    /* line-height: 24px; */\n    font-size: 12px !important;\n    font-weight: 400;\n    border: 0;\n    transition: 0.0s;\n    padding: 15px 0px 0px;\n    color: #535963 !important;\n    margin: 0 auto !important;\n    width: -webkit-fill-available;\n    text-align: left;\n    display: grid;\n    min-height: auto;\n    box-shadow: none !important;\n    /* height: 24px; */\n    /* border-radius: 0px !important; */\n    background: none;\n    /* border: 1px solid #2d303a; */\n    /* backdrop-filter removed: applied via universal (*) selector to every\n       child, creating a blur layer per element — costly with no visible gain */\n    /* min-width: 36px; */\n    opacity: 1;\n}\n\n/* .btn-group.btn-group-mini label.btn:hover{ background: #22242c !important; color: #f3bb2b !important; }  */\n\nbody.light_theme.btn-group.btn-group-mini * {\n    background: rgb(171 171 171 / 12%);\n    border: 1px solid rgb(234 239 244);\n    /* backdrop-filter removed: costly universal (*) selector */\n    color: #000;\n}\n\n\n.btn-check:active+.btn-outline-success:focus,\n.btn-check:checked+.btn-outline-success:focus,\n.btn-outline-success.active:focus,\n.btn-outline-success.dropdown-toggle.show:focus,\n.btn-outline-success:active:focus {\n    box-shadow: none !important;\n}\n\n.btn-group.btn-group-mini *:focus {\n    background: transparent;\n}\n\n.data-buy .btn-group.btn-group-mini .btn-outline-success {}\n\n.data-sell .btn-group.btn-group-mini .btn-outline-danger {}\n\n.btn-dark {\n    background: #ffffff26;\n}\n\n.btn-check+.btn:hover {\n    color: #ffffff;\n}\n\n.btn-check+.btn:hover {\n    color: var(--bs-btn-color);\n    background-color: var(--bs-btn-bg);\n    border-color: non;\n}\n\n.data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,\n.data-buy .btn-group.btn-group-mini .btn-outline-success:hover,\n.data-buy .btn-group.btn-group-mini .btn-outline-success.active {\n    background: #00000000;\n    border-color: #00000000;\n}\n\n.data-buy .btn-group.btn-group-mini .btn-outline-success.active {\n    background: rgba(2, 192, 118, 0.15) !important;\n    border-color: #fff !important;\n    color: #fff !important;\n}\n\n.data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,\n.data-sell .btn-group.btn-group-mini .btn-outline-danger:hover,\n.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {\n    background: #00000000;\n    border-color: #00000000;\n}\n\n.data-sell .btn-group.btn-group-mini .btn-outline-danger.active {\n    background: rgba(228, 85, 97, 0.15) !important;\n    border-color: #fff !important;\n    color: #fff !important;\n}\n\nhtml[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-check:checked+.btn-outline-success,\nhtml[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success:hover,\nhtml[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-check:checked+.btn-outline-danger,\nhtml[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger:hover {\n    background: #ffffff00 !important;\n    border-color: #ffffff00 !important;\n}\n\nhtml[data-theme='dark'] .data-buy .btn-group.btn-group-mini .btn-outline-success.active {\n    background: rgba(2, 192, 118, 0.15) !important;\n    border-color: #02c076 !important;\n    color: #ffff !important;\n}\n\nhtml[data-theme='dark'] .data-sell .btn-group.btn-group-mini .btn-outline-danger.active {\n    background: rgba(228, 85, 97, 0.15) !important;\n    border-color: #E45561 !important;\n    color: #ffff !important;\n}\n\n\n\n\n/* .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-success{ \n      border-color: var(--bs-green) !important;\n  }\n  .data-sell .btn-group.btn-group-mini .btn-check:checked + .btn-outline-danger{ \n      border-color: var(--bs-red) !important;\n  } */\n\n\n.trade-wrapper select,\n.trade-wrapper .nice-select {\n    box-shadow: rgb(106 106 106 / 21%) 0px 0px 0px 1px;\n    height: 44px;\n    background: #ffffff1a;\n    color: var(--white-color);\n    width: 100%;\n    /* backdrop-filter: blur(10px); */\n    border-radius: 50px;\n    padding: 0 16px;\n}\n\nbody.light_theme.trade-wrapper select,\nbody.light_theme.trade-wrapper .nice-select {\n    box-shadow: rgb(106 106 106 / 9%) 0px 0px 0px 1px;\n    background: rgb(245 245 245);\n}\n\n.trade-wrapper select *,\n.trade-wrapper .nice-select * {\n    /* font-size: 13px; */\n    color: #ffffff !important;\n    background: #000;\n}\n\nbody.light_theme.trade-wrapper select *,\nbody.light_theme.trade-wrapper .nice-select * {\n    color: #333333 !important;\n    background: #ffffff;\n}\n\n.num-select,\n.num-select:focus {\n    color: #fff !important;\n}\n\n.btn-block {\n    display: block;\n}\n\nsmall.note {\n    font-size: 74%;\n    display: block;\n    text-align: center;\n    margin: 18px 12px 0;\n    line-height: 1.2;\n}\n\n.buy_sell_cards button {\n    margin: 1.5rem 0 1rem;\n}\n\n.btn-group.btn-group-mini label.last-child {\n    text-align: right;\n    width: auto;\n}\n\n.btn-group.btn-group-mini label.last-child::before {\n    right: 0px;\n    left: inherit;\n}\n\n.trade_assets {\n    margin-top: 1rem;\n}\n\n.trade_assets .product-owner {\n    padding: 0.5rem 0;\n\n    border-bottom: 1px solid #2f2f39;\n}\n\n.trade_assets .product-owner:last-child {\n    border-bottom: 0;\n}\n\nbody.light_theme.trade_assets .product-owner {\n    border-color: rgb(0 0 0 / 5%);\n}\n\n\n.trade_card table.table,\n.trade_card tbody tr:hover {\n    background-color: transparent !important;\n}\n\n\n.form-select-sm {\n    padding: 9px 6px !important;\n    height: unset !important;\n    /* width: min-content !important; */\n    /* min-width: unset !important; */\n}\n\n.treade_card_header.tch_main_tab {\n    display: none;\n}\n\n.trade_card .table> :not(caption)>*>* {\n    padding: .5rem .5rem;\n    line-height: 1.5 !important;\n    vertical-align: middle;\n    font-size: 11px;\n    font-weight: 300;\n}\n\n.trade-wrapper .orderbook-table {\n    position: relative;\n}\n\n.trade-wrapper .orderbook-table th {\n    font-size: 12px;\n    align-items: start !important;\n    font-weight: 300;\n    color: #87909F;\n    position: static;\n    padding: 4px 10px;\n    top: 0;\n    z-index: 5;\n    background-color: #181a20 !important;\n}\n\n\n.trade_card .table>.btn {\n    margin: 0;\n}\n\n\n.spot-container-main .bottom {\n    display: flex;\n    min-height: 500px;\n    /*border-top: 1px solid #191e23;*/\n    flex: 1;\n}\n\n\n.bottom-left {\n    width: calc(100% - 380px);\n}\n\n.bottom-right {\n    width: 380px;\n}\n\nul.nav.custom-tabs.order_his_tabs li {\n    max-width: -webkit-fill-available;\n    width: auto;\n    padding: 0;\n}\n\nul.nav.custom-tabs.order_his_tabs {\n    justify-content: flex-start;\n}\n\nul.nav.custom-tabs.order_his_tabs li a {\n    padding: 8px 13px;\n    height: unset !important;\n    line-height: 1;\n}\n\n.ant-list-item {\n    display: flex;\n    height: 42px;\n    padding: 5px 16px;\n    cursor: pointer;\n}\n\n.rankItem {\n    height: 27px;\n    line-height: 12px;\n    width: 144px;\n}\n\n\n\n\n\n/* .spotLists {\n    width: 360px;\n    min-height: 360px;\n    max-width: calc(100% - 12px);\n    padding-bottom: 10px;\n    overflow-y: auto;\n    overflow-x: hidden; \n    position: absolute;\n    top: 128px;\n    left: 12px;\n    z-index: 111111;\n    border-radius: 9px;\n    display: none;\n    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;\n    padding: 0;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n} */\n\n.spotLists {\n    width: 100%;\n    min-height: 360px;\n    max-width: calc(100% - 12px);\n    padding-bottom: 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    /* background: #ffffff12; */\n    /* position: absolute; */\n    /* top: 128px; */\n    /* left: 12px; */\n    z-index: 111111;\n    border-radius: 9px;\n    display: none;\n    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;\n    padding: 0;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    max-width: 550px;\n}\n\n\n.spotLists.active {\n\n    display: block !important;\n\n}\n\n.show_spot {\n    display: block !important;\n}\n\n.spotList .scroll_y {\n    height: 357px;\n}\n\n.spot-list {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 360px;\n    min-height: 100%;\n    background: #1f252a;\n}\n\n.spot-list-search {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    padding: 10px;\n    padding-top: 0;\n}\n\n.spot-list-search .ivu-input {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    padding: 0 12px;\n}\n\nbody.light_theme.spot-list-search .ivu-input {\n    background: rgb(241 244 244);\n    border: 1px solid rgb(241 244 244);\n}\n\n.container-chart-briefing-info h6 {\n    font-size: 16px;\n}\n\n.spot-list-search i {\n\n    margin-right: 14px;\n}\n\n.spot-list-search .ivu-input input {\n    background: transparent;\n    border: 0;\n    outline: 0 !important;\n    color: var(--white-color);\n    padding: 6px 3px;\n    font-size: 14px;\n    width: 100%;\n}\n\nbody.light_theme .spot-list-search .ivu-input input {\n    color: #424242;\n}\n\n.spot-list-search .ivu-input input:focus {\n    border: none !important;\n\n}\n\n.price_card {\n    padding: 10px 0;\n    padding: 0;\n}\n\n.price_card .price_card_head {\n    padding: 0 15px;\n}\n\n.price_card_body {\n    padding: 0 10px;\n}\n\n.trade_history_tab .price_card_body {\n    padding: 0 15px;\n}\n\n#buy_orders .price_card_body.scroll_y.center_cntr {\n    justify-content: start;\n}\n\n#sell_orders .price_card_body.scroll_y.center_cntr {\n    justify-content: start;\n}\n\n.subhead_cntr {\n    font-size: 12px;\n    font-weight: 300;\n    justify-content: start;\n    text-align: left;\n    line-height: 15px;\n    color: #fff;\n}\n\nspan.tokensubcnt {\n    color: #949AA4;\n    font-size: 12px;\n}\n\n.trade_favourites_lft img.round_img {\n    width: 24px !important;\n    height: 24px !important;\n}\n\n.price_cntr_star i {\n    color: #565A62;\n    font-size: 17px !important;\n}\n\n.trade_favourites_lft .price_item_value {\n    padding: 10px\n}\n\n.price_cntr_star {\n    gap: 7px;\n}\n\n.trade_history_tab .price_card_head {\n    padding: 0px 15px;\n}\n\n.price_card_body.scroll_y {\n    padding-right: 5px;\n    padding-left: 5px;\n}\n\n.price_item_value .ri-xl {\n    font-size: 116%;\n}\n\n.spot-list-search .ivu-input::placeholder {\n    color: #ffffffde;\n}\n\n.buy_sell_cards ul.nav.custom-tabs li a.active {\n    color: #000 !important;\n    background-color: #fea903 !important;\n}\n\n\nbody.light_theme.container-chart-briefing .spotList {\n    background: #ffffff;\n    box-shadow: rgb(0 0 0 / 10%) 0px 4px 12px;\n}\n\n\n.trade-wrapper .favouriteData {\n    text-align: center;\n    padding: 5% 0;\n    /* font-size: 300%; */\n}\n\nhtml[data-theme='dark'] .trade-wrapper .favouriteData p {\n    color: #ffffff;\n    margin: 10px 0px;\n}\n\n\n.scroll_y .favouriteData {\n    height: 100%;\n}\n\n\n.btn.btn-warning {\n    background-color: #f3bb2b !important;\n    color: #222222 !important;\n    border-radius: 50px !important;\n}\n\n.mrkt_trde_tab {\n    display: flex;\n    align-items: center;\n    justify-content: start !important;\n    font-size: 18px;\n    padding: 8px;\n    margin: 00;\n    text-align: left;\n    background: #22242c00;\n}\n\n.option_datatable_bl .classic_favorites_bl .order_trade_s .table-trade {\n    padding: 0px 0px;\n}\n\n.option_datatable_bl .order_trade_s .buy_sell_row {\n    padding: 10px 10px 0px;\n}\n\n.option_datatable_bl .order_trade_s .price_card_head {\n    padding: 0px 10px;\n}\n\n.option_datatable_bl .buy_sell_row_price .scroll_y {\n    padding: 0px 10px;\n    height: 218px;\n}\n\n.trade-wrapper .text-success {\n    color: #01BC8D !important;\n}\n\nbody.light_theme.mrkt_trde_tab {\n    background: #f5f5f5;\n}\n\n\n\n\n.buysellform .input-group {\n    padding: 3px 10px;\n    display: flex;\n    align-items: center;\n    background: #2B313C;\n    border: 1px solid #2d303a00;\n    border-radius: 4px;\n    /* backdrop-filter removed: opaque background, blur not visible */\n}\n\nbody.light_theme.buysellform .input-group {\n    background: rgb(245 245 245);\n    border: 1px solid rgb(234 239 244);\n}\n\n.trade-wrapper.spot .tab-content>.tab-pane {\n    height: 100% !important;\n}\n\n\n.buysellform .input-group .form-control {\n    background: transparent;\n    border: 0;\n    padding-left: 0;\n    font-weight: 400;\n    padding-right: 0;\n    border-radius: 0 !important;\n    font-size: 12.2px !important;\n    backdrop-filter: unset !important;\n}\n\n.trade_card .table> :not(caption)>*>* {\n    font-size: 12px;\n    background-color: transparent;\n    color: #F2F4F6;\n}\n\ntable.table tbody tr:last-child td .favouriteData p {\n    font-size: 14px;\n}\n\n.buysellform .input-group .input-group-text,\n.buysellform .input-group .input-group-text * {\n    padding: 0;\n    margin: 0;\n    text-align: right !important;\n    display: block;\n}\n\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0px;\n    border-radius: 2px;\n    margin: 0px;\n    background: transparent !important;\n    line-height: 1;\n}\n\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li {\n    max-width: fit-content;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs {\n    justify-content: end;\n    gap: 4px;\n}\n\n\n\n.buy_sell_row h6 {\n    font-size: 12px;\n}\n\n.buy_sell_row {\n    border-bottom: 1px solid #ffffff1a;\n    margin-bottom: 10px;\n    padding: 10px 10px;\n}\n\nbody.light_theme.buy_sell_row {\n    border-bottom: 1px solid #d2e4ff;\n}\n\n.actv_data p,\n.actv_data span {\n    font-size: 13px;\n}\n\n\n.trade-wrapper .row {\n    margin-left: -5px;\n    margin-right: -5px;\n}\n\n/* .trade-wrapper .row > * {\n        padding-left: 5px;\n        padding-right: 5px;\n    }\n   */\n.trade-wrapper .mb-1 {\n    margin-bottom: 5px !important;\n}\n\n.num-select {\n    padding: 0 !important;\n    background: transparent !important;\n    border: 0 !important;\n    width: 32px !important;\n    outline: 0 !important;\n    box-shadow: none !important;\n    min-width: min-content !important;\n    text-align: right;\n    height: -moz-fit-content !important;\n    height: fit-content !important;\n    font-size: 13px;\n    line-height: 1.1;\n}\n\n.num-select * {\n    max-width: unset !important;\n    color: currentColor;\n}\n\nbody.light_theme.num-select * {\n    color: #fff !important;\n}\n\n.num-div {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    background-color: #2B313C;\n    padding: 4px;\n    border-radius: 4px;\n}\n\n.num-div .num-select {\n    font-size: 11px;\n    font-weight: 300;\n    color: #999;\n}\n\n.num-div:after {\n    font-family: \"remixicon\" !important;\n    font-style: normal;\n    content: \"\\ea4d\";\n    color: #535963;\n    font-size: 16px;\n    /* position: absolute; */\n    /* right: 0; */\n    /* top: 0; */\n    /* height: 15px; */\n    line-height: 1;\n}\n\n.trade_summary_table_lft .num-div {\n    background-color: transparent;\n}\n\n.freerate {\n    background-color: #2B313C;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    padding: 10px 20px;\n    border-radius: 4px;\n    font-size: 12px;\n    margin: 20px 0px 10px;\n}\n\n.freerate span {\n    color: #949AA4;\n}\n\nbody.light_theme.num-div:after {\n    color: #333;\n}\n\nbody.light_theme.num-div {\n    background: #ffffff;\n    color: #333 !important;\n}\n\nbody.light_theme.num-div select {\n    color: #333 !important;\n}\n\n.actv_sorting strong {\n    font-weight: 500;\n}\n\n\n.price_item_value.active {\n    background: #2B313C;\n}\n\nbody.light_theme.price_item_value.active {\n    background: #0000000d;\n}\n\n.trade_favourites_lft .spot-list-search .ivu-input {\n    background: #565A62;\n    border: none;\n    border-radius: 8px;\n    padding: 3px 12px;\n}\n\n.trade_favourites_lft .spot-list-search i {\n    margin-right: 5px;\n    color: #a9a9a9;\n}\n\n.trade-wrapper table tr td {\n    font-size: 12px !important;\n    font-weight: 300 !important;\n    padding: 2px 10px !important;\n}\n\n.trade_favourites_lft .price_card_body {\n    padding: 0px;\n}\n\n.trade_card.p-3 {\n    padding: 11px !important;\n}\n\n.trade_favourites_lft .price_card .price_card_head {\n    padding: 0 10px;\n}\n\n.assets_right .assets_list {\n    margin: 10px 0px;\n    padding-bottom: 2px;\n}\n\n.trade-wrapper .assets_right table tr td {\n    padding: 4px 10px;\n}\n\n\n.assets_right .price_card_body.scroll_y {\n    padding-right: 0px;\n    padding-left: 0px;\n}\n\n/* trade new css */\n\n.mt_tr_pr {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.mt_tr_pr .headline_bigName__dspVW i.faaa {\n    font-size: 20px;\n    opacity: 0.8;\n    font-weight: 100;\n    cursor: pointer;\n    margin-left: 6px;\n}\n\n.mt_tr_pr .headline_bigName__dspVW i.ri-menu-add-line:hover {\n    opacity: 1;\n}\n\n.spot-container {\n    max-width: 1520px;\n}\n\n.bs_dropbox .summay_dasboard_pop {\n    display: none !important;\n}\n\n.bs_dropbox .row .col-lg-6 {\n    width: 100% !important;\n    padding: 0px;\n}\n\n\n.bs_dropbox .trade_card.trade_chart.buysell_card {\n    width: 96.5%;\n    min-height: 722px;\n    position: relative;\n    left: 5px;\n}\n\n.treade_card_header {\n    border-bottom: 1px solid #2b2f39;\n    display: flex;\n    align-items: center;\n    padding-inline-start: 5px;\n    flex-shrink: 0;\n}\n\n.tch_main_tab {\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n}\n\n.tch_main_tab::-webkit-scrollbar {\n    display: none;\n}\n\nbody.light_theme .treade_card_header,\nbody.light_theme .price_card_head {\n    border-bottom: 1px solid #dadada;\n    opacity: 1;\n}\n\nbody.light_theme .card_header_title:before {\n    background-color: #cacaca;\n}\n\nbody.light_theme .card_header_title.active {\n    color: #3f3f3f;\n}\n\n\nbody.light_theme .headline_left__lBBPY .headline_symbolName__KfmIZ {\n    color: #262626;\n}\n\nbody.light_theme ul.favorites_list_tabs li button.active {\n    color: #525252;\n    border-bottom: 2px solid #5a5a5a;\n}\n\n.card_header_title {\n    height: 38px;\n    line-height: 38px;\n    padding: 0 10px;\n    cursor: pointer;\n    position: relative;\n    font-size: 14px;\n    font-weight: 400;\n    color: #949AA4;\n    font-family: \"Roboto\", sans-serif;\n}\n\n.trade_favourites_lft .spotLists {\n    display: block;\n    border-radius: 0px;\n    height: 99.6%;\n    padding-top: 12px;\n}\n\n.trade-wrapper .table-responsive {\n    min-height: 300px;\n    max-height: 570px;\n}\n\n.trade-wrapper div#tab_3.d-none.d-lg-block .table-responsive {\n    min-height: 570px; }\n\n.trade-wrapper div#tab_3.d-none.d-lg-block tr.no-data-row {\n        width: 100%;\n        height: 100%;\n        text-align: center;\n        display: contents;\n        justify-content: center;\n        align-items: center;\n    }\n\n.trade_card button.btn.btn-success {\n    color: #fff !important;\n    background-color: #5EBA89 !important;\n    border-radius: 50px;\n    font-size: 12px;\n    padding: 7px 16px;\n    border-color: #5EBA89;\n}\n\n.trade_card small {\n    font-size: 12px;\n    color: #949AA4;\n    padding-bottom: 10px;\n    margin-bottom: 0px !important;\n    display: block;\n}\n\n.spot_limit {\n    border-bottom: 1px solid #393F4F;\n}\n\n.spot_limit button {\n    background: transparent;\n    border: 0;\n    border-bottom: 2px solid #ffffff00;\n    padding: 0 0px 8px;\n    font-size: 14px;\n    font-weight: 400;\n    color: #949AA4;\n}\n\n.spot_limit button.active {\n    border-bottom: 2px solid #fff;\n    color: #fff;\n}\n\n.mrkt_trde_tab span {\n    font-size: 14px;\n    color: #87909F;\n}\n\n.trade-wrapper .assets_list .top_heading {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.assets_list .more_btn {\n    font-size: 12px;\n    color: #d3d3d3;\n}\n\n.trade-wrapper .assets_list h4 {\n    font-size: 15px;\n    font-weight: 400;\n    color: #dbdbdb;\n    margin: 0px;\n}\n\n.assets_btn button a {\n    color: #F2F4F6;\n    font-weight: 300;\n}\n\n.card_header_title:before {\n    position: absolute;\n    content: \" \";\n    width: 100%;\n    height: 2px;\n    border-radius: 0px;\n    background-color: #F2F4F6;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%) scaleX(.5);\n    opacity: 0;\n    transition: all .16s ease-in;\n}\n\n.card_header_title.active {\n    color: #F2F4F6;\n}\n\nbody.light_theme.card_header_title.active {\n    color: #000000;\n}\n\n.card_header_title.active:before {\n    opacity: 1;\n    transform: translateX(-50%) scaleX(1);\n}\n\n.nav.custom-tabs.nav_order {\n    width: auto !important;\n}\n\n.trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* height: 26px; */\n    padding: 10px 15px 5px;\n    border: 0;\n    margin: 0;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {\n    background: transparent !important;\n}\n\n.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {\n    background: #262933 !important;\n}\n\nbody.light_theme.buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {\n    background: #e9e9e9 !important;\n}\n\nbody.light_theme.price_card_head {\n    border-color: #00000012;\n}\n\n.scroll_y_hidden {\n    overflow: hidden;\n}\n\n\n\n.headline_left__lBBPY {\n    display: flex;\n    align-items: center;\n}\n\n.headline_left__lBBPY .headline_symbolName__KfmIZ {\n    white-space: nowrap;\n    margin-right: 0;\n    cursor: pointer;\n}\n\n.headline_bigName__dspVW {\n    display: flex;\n    align-items: center;\n    -webkit-margin-end: 7px;\n    margin-inline-end: 7px;\n}\n\n.headline_bigName__dspVW,\n.headline_bigName__dspVW h1 {\n    line-height: 20px;\n    font-size: 14px !important;\n    font-weight: 600;\n}\n\n.headline_bigName__dspVW h1 {\n    margin: 0;\n}\n\n.headline_etfDisplay__P4Hdv {\n    font-size: 10px;\n    line-height: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    -webkit-margin-end: 10px;\n    margin-inline-end: 10px;\n    opacity: 0.7;\n}\n\n.headline_leftItem__7BFYq {\n    margin-inline-start: 15px;\n    font-size: 12px;\n    color: #949AA4;\n    line-height: 20px;\n    white-space: nowrap;\n    font-weight: normal;\n    font-weight: 400;\n}\n\n\n\n/* token info */\n\n.inf_row {\n    padding: 1.5rem;\n}\n\n.inf_row .mt_tr_pr {\n    margin-bottom: 16px;\n}\n\n.inf_row .headline_bigName__dspVW,\n.headline_bigName__dspVW h1 {\n    font-size: 14px !important;\n}\n\n\n.infor_row li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.infor_row li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    padding: 8px 0;\n}\n\n.infor_row li span {\n    font-weight: 500;\n    color: #fff;\n}\n\nbody.light_theme.infor_row li span {\n    color: #000;\n}\n\n\n.orderbook_two .buy_sell_row_price .scroll_y {\n    height: 257px;\n}\n\n.t_info h5 {\n    font-size: 15px;\n    font-weight: 600;\n}\n\n.t_info p {\n    font-weight: 300;\n    font-size: 13px;\n}\n\n.inf_row {\n    padding: 1.5rem;\n    height: 429px;\n    overflow-y: auto;\n}\n\n@media (min-width:1601px) {\n    .headline_leftItem__7BFYq {\n        margin-inline-start: 30px;\n    }\n\n}\n\n.headline_latestPrice__AYXu0 .headline_title__x1csO {\n    font-size: 14px;\n}\n\n.scroll-subtabs_scrollSubInfo__T5nZF {\n    flex: 1 1;\n    width: 0;\n    margin-inline-start: 0;\n    position: relative;\n}\n\n.scroll-subtabs_tabs__Prom8 {\n    flex-flow: row nowrap;\n    display: flex;\n    /* overflow: hidden; */\n    position: relative;\n}\n\n.scroll-subtabs_subMarketWrap__XVmHp {\n    overflow: auto hidden;\n    white-space: nowrap;\n    scroll-behavior: smooth;\n    scrollbar-width: none;\n}\n\n.headline_extendInfoWrapper__dooIS,\n.headline_left__lBBPY,\n.headline_wrapper__BKn9L {\n    display: flex;\n    align-items: center;\n}\n\n.headline_leftItem__7BFYq {\n    /* margin-inline-end: 60px; */\n    font-size: 10.5px;\n    line-height: 20px;\n    white-space: nowrap;\n}\n\n.headline_withBorder__a6ZD2 {\n    border-bottom: 1px dashed transparent;\n    opacity: 0.7;\n}\n\n\n\n\n.buysell_heder {\n    padding: 14px !important;\n}\n\n.buysell_heder .custom-tabs {\n    padding: 0px 5px;\n    width: 100%;\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    border-radius: 0px;\n    gap: 10px;\n    background-color: transparent;\n    flex-wrap: nowrap;\n}\n\n\nbody.light_theme .buysell_heder .custom-tabs {\n    background: #dddddd;\n}\n\nbody.light_theme .spot_limit button.active {\n    border-bottom: 2px solid #696969;\n    color: #696969;\n}\n\nbody.light_theme .actions_balance__kTHO0 {\n    color: #000;\n}\n\nbody.light_theme .buysellform .input-group {\n    background: #dddddd;\n}\n\nbody.light_theme .assets_list ul li {\n    color: #000;\n}\n\nbody.light_theme .assets_list ul li span {\n    color: #3a3a3a;\n}\n\nbody.light_theme .spotLists {\n    background: #ececec;\n}\n\n\nbody.light_theme .trade_favourites_lft .spot-list-search .ivu-input {\n    background: #dddddd;\n}\n\nbody.light_theme .trade_card {\n    background: #ececec;\n}\n\n.buysell_heder .custom-tabs li {\n    width: 50%;\n    position: relative;\n}\n\n.status_info {\n    display: flex;\n    gap: 5px;\n}\n\n.status_info input {\n    background-color: #999;\n    border: 1px solid #666;\n    border-radius: 50px;\n}\n\n.status_info input {\n    background-color: #22242c;\n    border: 1px solid #353535;\n    border-radius: 50px;\n    color: #fff;\n    padding: 2px 12px;\n    width: 130px;\n}\n\n.status_info button {\n    border-radius: 50px !important;\n}\n\n.buysell_heder .custom-tabs li a {\n    width: 100%;\n    display: block;\n    /* transform: skewX(-20deg); */\n    text-align: center;\n    padding: 6px 0;\n    /* background-color: #ffffff0f; */\n    border-radius: 4px;\n    font-size: 12px;\n    color: currentColor !important;\n    transition: unset !important;\n}\n\n/* .buysell_heder .custom-tabs li a::before{     width: 16px;\n    transform: rotate(-19deg);\n    position: absolute;\n    left: -6px;\n    background-color: #1f1f22;\n    height: 110%;\n    content: \"\";\n    top: -3px; } */\n\n.buysell_heder .custom-tabs li a.active button {\n    background: #5EBA89 !important;\n    color: #fff;\n}\n\n/* .buysell_heder .custom-tabs li.sell-tab button::before {\n    left: inherit;\n    background-color: #1f1f22;\n    right: -6px;\n    top: 0px;\n} */\n\n/* .buysell_heder .custom-tabs li.sell-tab a.active::before{ background-color: #ed5765 !important; } */\n\n/* .buysell_heder .custom-tabs li.buysell-tab.buy-tab button {\n    border-radius: 4px;\n    -ms-transform: skewX(-20deg);\n    -webkit-transform: skewX(-20deg);\n    transform: skewX(-20deg);\n} */\n\n.buysell_heder .custom-tabs.padding-0 li a {\n    padding: 0px !important;\n}\n\n/* .buysell_heder .custom-tabs li button span {\n    -ms-transform: skewX(20deg);\n    -webkit-transform: skewX(20deg);\n    transform: skewX(20deg);\n    display: block;\n} */\n\n/* .buysell_two .buysell_heder .custom-tabs li button span {\n    -ms-transform: skewX(35deg);\n    -webkit-transform: skewX(35deg);\n    transform: skewX(35deg);\n    display: block;\n} */\n\n.actions_balance__kTHO0 {\n    margin-bottom: 12px;\n    min-height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n    font-weight: 300;\n}\n\n.midgraph_col {\n    position: relative;\n}\n\nul.favorites_list_tabs {\n    display: flex;\n    gap: 18px;\n    align-items: center;\n    border-bottom: 1px solid #565656;\n    margin: 12px 15px;\n}\n\nul.favorites_list_tabs li button {\n    font-size: 14px;\n    font-weight: 500;\n    color: #949AA4;\n    background-color: transparent;\n    border-bottom: 2px solid #565656;\n    border: none;\n    padding: 0px 0px 8px;\n}\n\nul.favorites_list_tabs li button.active {\n    color: #fff;\n    border-bottom: 2px solid #fff;\n}\n\n.midgraph_col .trade_card.trade_chart {\n    min-height: 91%;\n}\n\n.actions_primaryText__ufKT0 {\n    opacity: 0.7;\n    margin-right: 10px;\n}\n\nbody.light_theme.actions_primaryText__ufKT0 {\n    opacity: 1;\n}\n\nbody.light_theme.actions_balance__kTHO0 .text-muted {\n    color: #3b3d3e !important;\n}\n\na.actions_deposit__Ydutk {\n    color: #01BC8D;\n    font-size: 125%;\n    margin-left: 10px;\n    line-height: 1;\n}\n\n.buysellform .form-group label {\n    display: block;\n    margin-bottom: 4px;\n    font-weight: 300;\n    font-size: 12px;\n    /* opacity: 0.7; */\n    color: #F2F4F6;\n}\n\n.assets_list ul li span {\n    color: #c0c0c0;\n}\n\n.process_step {\n    position: relative;\n}\n\n.process_step:before {\n    width: 100%;\n    background-color: #393F4F40;\n    height: 2px;\n    position: absolute;\n    content: \"\";\n    left: 0px;\n    top: 3px;\n}\n\n.process_step label.btn {\n    position: relative;\n}\n\n.process_step label.btn:before {\n    width: 7px;\n    background-color: #393F4F40;\n    height: 7px;\n    position: absolute;\n    content: \"\";\n    border-radius: 50px;\n    border: 1px solid #393F4F;\n    left: 0px;\n    top: 1px;\n}\n\n\n.process_step label.btn.checked:before {\n    width: 14px;\n    background-color: #181a20;\n    height: 14px;\n    border: 2px solid #F2F4F6;\n    top: -3px;\n}\n\n.buysell_heder .custom-tabs {\n    padding: 5px;\n    width: 100%;\n    display: flex;\n    position: relative;\n    overflow: inherit;\n    border: none;\n    border-radius: 50px;\n    gap: 10px;\n    background-color: #2B313C;\n    flex-wrap: nowrap;\n}\n\n.buysell_heder .custom-tabs li button {\n    width: 100%;\n    display: block;\n    /* transform: skewX(-20deg); */\n    text-align: center;\n    border: none;\n    font-weight: 400;\n    padding: 6px 10px;\n    background-color: #2B313C;\n    border-radius: 50px;\n    font-size: 14px;\n    color: #87909F;\n    transition: unset !important;\n}\n\n.relative_select_right .buysell_heder .custom-tabs li.active button {\n    background-color: #5EBA89 !important;\n    border-bottom: none !important;\n}\n\n.relative_select_right .buysell_heder .custom-tabs li.selltab.active button {\n    background-color: #ed5765 !important;\n}\n\n.selltab\n/* .buysell_heder .custom-tabs li button::before {\n    width: 16px;\n    transform: rotate(0deg);\n    position: absolute;\n    transform: skewX(20deg);\n    left: -6px;\n    background-color: #1f1f22;\n    height: 100%;\n    content: \"\";\n    border-radius: 3px;\n    top: 0px;\n} */\n\n\n/* .buysell_heder .custom-tabs li.active button::before {\n    background: #01BC8D !important;\n}\n\n.buysell_heder .custom-tabs li a.active button::before {\n    background: #01BC8D !important;\n}\n\n.buysell_heder .custom-tabs li button.active::before {\n    background: #01BC8D !important;\n}\n\n.buysell_heder .custom-tabs li button.selltab::before {\n    left: inherit;\n    background-color: #1f1f22;\n    right: -5px;\n    top: 0px;\n    border-radius: 3px;\n} */\n\n.buysell_heder.padding_space_l {\n    padding: 0px !important;\n}\n\n.relative_select_right .cnt_table_two {\n    display: none;\n}\n\n.relative_select_right .cnt_table_two.active {\n    display: block;\n}\n\n/* .buysell_two .buysell_heder .custom-tabs li button::before {\n    width: 28px;\n    transform: skewX(35deg);\n    left: -11px;\n}\n\n.buysell_two .buysell_heder .custom-tabs li.sell-tab button::before {\n    left: inherit;\n    background-color: #1f1f22;\n    right: -10px;\n    top: 0px;\n} */\n\n.buysell_two .buysell_heder .custom-tabs li.sell-tab a.active button {\n    background-color: #ed5765 !important;\n}\n\n/* .buysell_heder .custom-tabs li.sell-tab a.active button:before {\n    background-color: #ed5765 !important;\n}\n\n.buysell_heder .custom-tabs li.selltab button.active::before {\n    background-color: #ed5765 !important;\n} */\n\n\nbody.light_theme.buysellform .form-group label {\n    opacity: 1;\n}\n\n.order-btns .btn-mini {\n    margin: 5px 0;\n    line-height: 1;\n    min-height: 36px;\n}\n\n\n.bs_box_header {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 13px;\n}\n\n.bs_box_header h6 {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0;\n}\n\n.bs_box_header i {\n    font-size: 22px;\n}\n\n\n\n.bs_tab_row {\n    position: fixed;\n    bottom: 0;\n    z-index: 9999;\n    width: 100%;\n    left: 0;\n    padding: 13px;\n    border-radius: 0;\n    border: 0;\n    -webkit-backdrop-filter: blur(10px);\n    backdrop-filter: blur(10px);\n    background: #1e1d3054;\n    border-top: 1px solid #2c2c3d8a;\n}\n\nbody.light_theme.bs_tab_row {\n    background: #ffffffc9;\n    border-color: #F5F5F5;\n}\n\n.bs_tab_row .btn {\n    font-weight: 500;\n}\n\n\n.bs_dropbox.spotLists_bs_dropbox {\n    display: none;\n}\n\n.bs_dropbox.spotLists_bs_dropbox.active {\n    display: flex;\n}\n\n\n\n.spotLists_bs_dropbox {\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: #00000075;\n    top: 0;\n    bottom: 0;\n    z-index: 99;\n    left: 0;\n    align-items: center;\n    justify-content: center;\n\n}\n\n\n\n@media screen and (max-width: 1100px) and (min-width: 768px) {\n\n    .mmn_btm_minus_spc .col-lg-6 {\n        margin: -1px;\n    }\n\n    div#tab_3 {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    div#tab_4 {\n        margin-top: -17px !important;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n\n\n}\n\n\n\n@media screen and (max-width: 767px) and (min-width: 320px) {\n\n    .treade_card_header.tch_main_tab {\n        display: flex;\n    }\n\n    .headline_bigName__dspVW h1 i {\n        display: flex;\n    }\n\n    div#tab_3 {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Hide tab_3 on mobile when Chart tab is active */\n    div#tab_3.d-none {\n        display: none !important;\n    }\n\n    div#tab_mobile_trade_history {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Hide mobile Market Trades when Chart tab is active */\n    div#tab_mobile_trade_history.d-none {\n        display: none !important;\n    }\n\n    /* Mobile Market Trades styling */\n    div#tab_mobile_trade_history .trade_history_tab {\n        padding: 0;\n    }\n\n    div#tab_mobile_trade_history .table-responsive {\n        max-height: calc(100vh - 400px);\n        overflow-y: auto;\n    }\n\n    div#tab_mobile_trade_history .price_card_body {\n        padding: 0;\n    }\n\n    div#tab_4 {\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Hide mobile Wallets when Chart tab is active */\n    div#tab_4_mobile.d-none {\n        display: none !important;\n    }\n\n    div#tab_4_mobile {\n        height: 100%;\n        margin-top: 0px;\n        border-radius: 0px 0px 10px 10px;\n    }\n\n    /* Mobile Wallets styling */\n    div#tab_4_mobile .assets_list {\n        padding: 0px;\n    }\n\n    .assets_btn {\n        gap: 10px;\n    }\n\n    div#tab_4_mobile .table-responsive {\n        max-height: calc(100vh - 400px);\n        overflow-y: auto;\n    }\n\n    div#tab_4_mobile .price_card_body {\n        padding: 0;\n    }\n\n    .trade-wrapper.spot.pb-3 .col-12.col-lg-6.col-xl-3.col-xxl-3 {\n        margin-top: 7px;\n    }\n\n\n    .mmn_btm_minus_spc .col-lg-6 {\n        margin-top: -2px;\n    }\n\n    .trade-wrapper {\n        padding-top: 10px !important;\n        overflow-x: hidden;\n    }\n\n    .select_mini {\n        font-size: 14px;\n        min-width: initial !important;\n        height: unset !important;\n        padding: 5px 11px !important;\n    }\n\n\n    .container-chart-briefing .spotList {\n        background: #22242c;\n        left: 0;\n        top: 62px;\n    }\n\n\n    .container-chart-briefing {\n        height: auto;\n        padding: 15px 15px 0;\n    }\n\n    .spot-container-main .top {\n        flex-direction: column;\n    }\n\n    .spot-container {\n        flex-direction: column;\n    }\n\n    .wm-50 {\n        flex: 0 0 auto;\n        margin-bottom: 17px;\n        width: 50%;\n    }\n\n    .container-chart-briefing-info {\n        width: 100%;\n        justify-content: unset;\n        flex-wrap: wrap;\n    }\n\n    .container-chart-briefing h2 {\n        justify-content: flex-start;\n    }\n\n    .spot-container-main .bottom {\n        min-height: unset;\n        flex-direction: column;\n    }\n\n    .bottom-left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .bottom-right {\n        width: 100%;\n    }\n\n    .spot-container-right-right {\n        flex: auto;\n        max-width: 100%;\n    }\n\n    .trade_card {\n        padding: 11px 11px;\n        padding: 0;\n    }\n\n    ul.nav.custom-tabs.order_his_tabs li a {\n        padding: 8px 13px;\n        font-size: 13px;\n        line-height: 1;\n    }\n\n    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a {\n        padding: 3px;\n        margin: 0 3px 0 0;\n    }\n\n    .buy_sell_row.buy_sell_cards ul.nav.custom-tabs li a.active {\n        background: transparent !important;\n    }\n\n}\n\n\n@media screen and (max-width: 991px) and (min-width: 768px) {\n\n\n    .spot-container-main .top {\n        flex-direction: column;\n    }\n\n    .spot-container {\n        flex-direction: column;\n    }\n\n    .wm-50 {\n        flex: 0 0 auto;\n        margin-bottom: 17px;\n        width: 33.3333333%;\n    }\n\n    .container-chart-briefing-info {\n        width: 100%;\n        justify-content: unset;\n        flex-wrap: wrap;\n    }\n\n    .container-chart-briefing h2 {\n        justify-content: flex-start;\n    }\n\n    .spot-container-main .bottom {\n        min-height: unset;\n        flex-direction: column;\n    }\n\n    .bottom-left {\n        width: 100%;\n        margin-bottom: 20px;\n    }\n\n    .bottom-right,\n    .spot-container-main .top-right {\n        width: 100%;\n    }\n\n    .spot-container-right-right {\n        flex: auto;\n        max-width: 100%;\n    }\n\n    ul.nav.custom-tabs.order_his_tabs li a {\n        padding: 7px 20px;\n        font-size: 14px;\n    }\n\n    .container-chart-briefing {\n        height: unset;\n        padding-bottom: 10px;\n    }\n\n    .trade-wrapper.spot {\n        max-width: 650px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .trade-wrapper.spot.pb-3 {\n        max-width: 100%;\n    }\n\n\n}\n\n\n@media screen and (max-width: 1299px) and (min-width: 992px) {\n\n    .spot-container {\n        flex-direction: column;\n    }\n\n    .spot-container-right-right {\n        flex: auto;\n        max-width: 100%;\n        display: flex;\n    }\n\n    /* .inner-page-banner {\n            padding: 77px 0 43px;\n        } */\n    section.pb-90.account_sec {\n        padding-bottom: 0;\n    }\n}\n\n@media screen and (max-width:1550px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 33.6%);\n    }\n\n    ul.favorites_list_tabs {\n        gap: 12px;\n        margin: 12px 7px;\n    }\n\n    .trade_card .table> :not(caption)>*>* {\n        font-size: 11px;\n    }\n\n    .trade-wrapper .orderbook-table th {\n        padding: 4px 7px;\n    }\n\n    .trade-wrapper .orderbook-table td {\n        padding: 4px 7px;\n    }\n\n    ul.favorites_list_tabs li button {\n        font-size: 13px;\n    }\n\n}\n\n@media screen and (max-width:1440px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 237px);\n    }\n\n    .assets_btn {\n        gap: 10px;\n    }\n\n    .trade-wrapper .orderbook-table th {\n        font-size: 10px !important;\n        padding: 4px 5px;\n    }\n\n    .trade-wrapper .orderbook-table td {\n        font-size: 10px !important;\n        padding: 4px 5px !important;\n    }\n\n    .card_header_title {\n        font-size: 12px;\n    }\n\n    ul.favorites_list_tabs li button {\n        font-size: 12px;\n        padding: 0px 0px 5px;\n    }\n\n    ul.favorites_list_tabs {\n        gap: 10px;\n        margin: 5px 5px;\n    }\n\n    .assets_btn button {\n        font-size: 12px;\n        padding: 5px 5px;\n    }\n\n}\n\n@media screen and (max-width:1367px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 226px);\n    }\n\n    .trade_favourites_lft .spotLists {\n        height: 100%;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        width: 98.5%;\n    }\n\n    div#tab_3 {\n        border-radius: 0px;\n    }\n\n\n}\n\n\n@media screen and (max-width: 1200px) {\n\n    .trade_card.p-2.overflow_card.mb-1 {\n        width: calc(100% + 0px);\n    }\n\n    .midgraph_col {\n        width: 70%;\n    }\n\n    .trade_favourites_lft {\n        width: 30%;\n    }\n\n    .trade-wrapper .row {\n        row-gap: 24px;\n    }\n\n    div#tab_3 {\n        border-radius: 0px;\n    }\n\n    div#tab_4 {\n        border-radius: 10px;\n        margin-top: 0px !important;\n    }\n\n}\n\n/* Ensure tab_3 shows on desktop (lg+) even if d-none is present */\n@media screen and (min-width: 992px) {\n    div#tab_3.d-none.d-lg-block {\n        display: block !important;\n    }\n}\n\n@media screen and (max-width: 991px) {\n\n    .midgraph_col {\n        width: 60%;\n    }\n\n    .trade_favourites_lft {\n        width: 40%;\n    }\n\n    .bs_tab_row {\n        z-index: 999999;\n    }\n\n    .mmn_btm_minus_spc button.btn.btn-danger {\n        font-size: 12px;\n        padding: 6px 16px;\n    }\n\n    .bs_tab_row button.btn.btn-success {\n        padding: 6px 16px;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        left: 1px;\n    }\n\n}\n\n\n@media screen and (max-width: 1600px) and (min-width: 1200px) {\n    .spot-container .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 24%;\n    }\n\n    .spot-container .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 48%;\n    }\n\n    .spot-container .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 52%;\n    }\n}\n\n@media screen and (max-width: 3000px) and (min-width: 1601px) {\n    .spot-container .col-xxl-2 {\n        flex: 0 0 auto;\n        width: 20%;\n    }\n\n    .spot-container .col-xxl-4 {\n        flex: 0 0 auto;\n        width: 40%;\n    }\n\n    .spot-container .col-xxl-8 {\n        flex: 0 0 auto;\n        width: 60%;\n    }\n}\n\n.scroll_y_reverse {\n    display: flex;\n    flex-direction: column-reverse;\n}\n\n\n.font-weight-boldd {\n    font-weight: 600;\n}\n\n\n\n\n/* responsive */\n@media (max-width: 767px) {\n\n    /* Mobile Favourites Toggle Button */\n    .mobile-favourites-toggle-btn {\n        display: block;\n        margin-bottom: 15px;\n    }\n\n    .favourites-toggle-btn-mobile {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 10px 20px;\n        background-color: #2B313C;\n        border: 1px solid #434343;\n        border-radius: 8px;\n        color: #fff;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.3s ease;\n    }\n\n    .favourites-toggle-btn-mobile:hover {\n        background-color: #373E4B;\n        border-color: #565A62;\n    }\n\n    .favourites-toggle-btn-mobile:focus-visible {\n        background-color: #373E4B;\n        border-color: #565A62;\n    }\n\n    .favourites-toggle-btn-mobile:active {\n        background-color: #373E4B !important;\n        border-color: #565A62 !important;\n    }\n\n    .favourites-toggle-btn-mobile i {\n        font-size: 16px;\n    }\n\n    body.light_theme.favourites-toggle-btn-mobile {\n        background-color: #f5f5f5;\n        border-color: #e0e0e0;\n        color: #333;\n    }\n\n    body.light_theme.favourites-toggle-btn-mobile:hover {\n        background-color: #e9e9e9;\n        border-color: #d0d0d0;\n    }\n\n    .trade_favourites_lft.hide-favourites-mobile {\n        display: none;\n    }\n\n    .trade_favourites_lft.show-favourites-mobile {\n        display: block;\n    }\n\n    .midgraph_col {\n        width: 100%;\n    }\n\n    .trade_favourites_lft {\n        width: 100%;\n        display: none;\n    }\n\n    /* Mobile Favourites Popup */\n    .mobile-favourites-popup-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: rgba(0, 0, 0, 0.7);\n        z-index: 999999;\n        display: flex;\n        align-items: flex-end;\n        justify-content: center;\n        animation: fadeIn 0.3s ease;\n    }\n\n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n        }\n\n        to {\n            opacity: 1;\n        }\n    }\n\n    @keyframes slideUp {\n        from {\n            transform: translateY(100%);\n        }\n\n        to {\n            transform: translateY(0);\n        }\n    }\n\n    .mobile-favourites-popup {\n        width: 100%;\n        max-height: 85vh;\n        background-color: #2b313c;\n        border-top-left-radius: 0px;\n        border-top-right-radius: 0px;\n        display: flex;\n        flex-direction: column;\n        animation: slideUp 0.3s ease;\n        overflow: hidden;\n        border-radius:10px 10px 0px 0px;\n    }\n\n    .mobile-favourites-popup .orderbook-table th {\n        background: #2b313c;\n    }\n\n    .headline_bigName__dspVW h1 {\n        display: flex;\n    }\n\n    body.light_theme.mobile-favourites-popup {\n        background-color: #ffffff;\n    }\n\n    .mobile-favourites-popup-header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 9px 15px 5px;\n        border-bottom: none;\n    }\n\n    body.light_theme.mobile-favourites-popup-header {\n        border-bottom-color: #e0e0e0;\n    }\n\n    .mobile-favourites-popup-header h4 {\n        margin: 0;\n        font-size: 15px;\n        font-weight: 400;\n        color: #fff;\n    }\n\n    body.light_theme.mobile-favourites-popup-header h4 {\n        color: #333;\n    }\n\n    .mobile-favourites-close-btn {\n        background: transparent;\n        border: none;\n        color: #9b9b9b;\n        font-size: 22px;\n        cursor: pointer;\n        padding: 5px;\n        font-weight: 300;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n        transition: background-color 0.2s ease;\n    }\n\n    .mobile-favourites-close-btn:hover {\n        background-color: rgba(255, 255, 255, 0.1);\n    }\n\n    body.light_theme.mobile-favourites-close-btn {\n        color: #333;\n    }\n\n    body.light_theme.mobile-favourites-close-btn:hover {\n        background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    .mobile-favourites-popup-content {\n        flex: 1;\n        overflow-y: auto;\n    }\n\n    .mobile-favourites-popup-content .spotLists {\n        background: transparent;\n        padding: 0;\n        display: block;\n        top: 0px;\n        max-width: calc(100% - 0px);\n        left: 0px;\n    }\n\n    .mobile-favourites-popup-content ul.favorites_list_tabs {\n        padding: 0px 10px;\n    }\n\n    .mobile-favourites-popup-content img.round_img {\n        width: 18px !important;\n        height: 18px !important;\n    }\n\n    .orderbook-table td {\n        padding: 4px 7px;\n    }\n\n    ul.favorites_list_tabs li button {\n        font-size: 12px;\n    }\n\n    ul.favorites_list_tabs {\n        gap: 15px;\n        margin: 7px 0px;\n    }\n\n    .headline_left__lBBPY_leftmain.d-flex.align-items-center {\n        width: 50%;\n    }\n\n    .scroll-subtabs_subMarketWrap__XVmHp {\n        /* max-width: 264px; */\n        min-width: 194px;\n    }\n\n    .mmn_btm_minus_spc {\n        margin-bottom: -.5rem;\n    }\n\n    .tch_main_tab .card_header_title {\n        height: 32px;\n        line-height: 32px;\n        padding: 1px 7px;\n    }\n\n    .trade_summary_table_lft {\n        padding: 10px !important;\n    }\n\n    .trade-wrapper.spot {\n        padding-top: 3px !important;\n    }\n\n    .infor_row li {\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 18px;\n        padding: 5px 0;\n    }\n\n    .inf_row {\n        padding: 1rem;\n        height: 429px !important;\n        overflow-y: auto;\n    }\n\n\n\n    .scroll-subtabs_scrollSubInfo__T5nZF {\n        flex: 1 1;\n        width: 0;\n        margin-inline-start: 0;\n        position: relative;\n    }\n\n    .headline_left__lBBPY_leftmain.d-flex.align-items-center {\n        flex-direction: column;\n        align-items: flex-start !important;\n        justify-content: flex-start;\n    }\n\n    .headline_left__lBBPY_leftmain .headline_symbolName__KfmIZ {\n        margin-bottom: 0;\n    }\n\n    /* .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {\n        flex-direction: column;\n        align-items: flex-start !important;\n    } */\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 5px;\n        align-items: flex-start !important;\n    }\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq {\n        display: flex;\n        width: 100%;\n        justify-content: flex-end;\n    }\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_withBorder__a6ZD2 {\n        flex: 1 1;\n        font-size: 9px;\n        text-align: start;\n        margin-inline-end: 0;\n    }\n\n    .headline_left__lBBPY_rightmain .headline_extendInfoWrapper__dooIS .headline_leftItem__7BFYq .headline_title__x1csO {\n        flex: 1 1;\n        text-align: right;\n        -webkit-margin-end: 0;\n        margin-inline-end: 0;\n    }\n\n    .headline_latestPrice__AYXu0 .headline_title__x1csO {\n        font-size: 16px;\n    }\n\n    .trade-wrapper .assets_list h4 {\n        font-size: 14px;\n        align-items: center;\n        gap: 5px;\n        display: flex;\n    }\n\n    .inf_row .headline_bigName__dspVW,\n    .headline_bigName__dspVW h1 {\n        font-size: 14px !important;\n    }\n\n    span.headline_change__tGyxo {\n        font-size: 16px;\n    }\n\n    .headline_leftItem__7BFYq {\n        /* margin-inline-end: 60px; */\n        font-size: 12px;\n        line-height: 1.2;\n        white-space: nowrap;\n        padding: 4px 0;\n        font-weight: normal;\n    }\n\n    .headline_leftItem__7BFYq {\n        margin-inline-start: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: start;\n        gap: 3px;\n    }\n\n    .scroll-container {\n        overflow-y: auto;\n        max-height: 175px;\n        height: auto;\n    }\n\n    .exchange_chartContent__Ijukg {\n        height: auto;\n        overflow-y: auto;\n    }\n\n    .information_bright__F_RTd {\n        opacity: 1 !important;\n        margin-left: 6px;\n    }\n\n    .information_left__vgFSY,\n    .information_right__kqyPI {\n        width: 41%;\n    }\n\n    .trade-wrapper .btn {\n        height: auto !important;\n        min-height: unset !important;\n        margin-top: 5px;\n        border-radius: 50px;\n    }\n\n    .btn-group.btn-group-mini {\n        margin-bottom: 3px;\n    }\n\n    .btn-group.btn-group-mini * {\n        padding: 0px 0px;\n        min-height: unset;\n        border-radius: 9px !important;\n        line-height: 29px;\n        font-size: 11px !important;\n    }\n\n    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-2,\n    .col-12.col-sm-6.col-lg-6.col-xl-3.col-xxl-2.order-3.order-xl-3 {\n        margin-top: 0;\n    }\n\n    .price_card_body.price_card_body_full,\n    .scroll_y {\n        height: 240px;\n    }\n\n    .scroll_y_full {\n        height: 502.8px;\n    }\n\n    .scroll_y_full {\n        /* height: 480px; */\n    }\n\n    .scroll_y_coins {\n        height: 339px;\n    }\n\n    footer.footer-wrapper {\n        margin-top: 0;\n    }\n\n\n\n    .trade-wrapper .container-fluid {\n        padding-right: 8px;\n        padding-left: 8px;\n        overflow: hidden;\n    }\n\n    .scroll-subtabs_tabs__Prom8 {\n        justify-content: flex-end;\n    }\n\n\n    .trade_tabs .num-select {\n        font-size: 10px;\n    }\n\n    .buysell_heder {\n        padding: 10px !important;\n    }\n\n    .spot .form-control,\n    .spot select {\n        padding: 7px 18px;\n        min-width: unset;\n    }\n\n    .trade_chart .form-select-sm {\n        padding: 6px 9px !important;\n        font-size: 12px;\n    }\n\n    .actions_balance__kTHO0 {\n        flex-direction: column;\n        align-items: start;\n        line-height: 1.5;\n    }\n\n    .actions_primaryText__ufKT0 {\n        opacity: 0.7;\n        margin-right: 10px;\n        font-size: 10px;\n        margin-bottom: 3px;\n    }\n\n    .trade-wrapper .mb-1 {\n        margin-bottom: 4px !important;\n    }\n\n    .price_card_head>div {\n        word-break: break-all;\n        font-size: 10px;\n        vertical-align: bottom;\n        padding: 0 6px;\n    }\n\n    .price_card .price_card_head {\n        padding: 0 5px;\n        margin: 0;\n        min-height: 24px;\n        line-height: 1.1;\n    }\n\n    .trade_tabs.buy_sell_cards.buy_sell_row.d-flex-between {\n        padding: 0px 7px 0px 9px;\n    }\n\n    .price_item_value span:first-child,\n    .price_card_head>div:first-child {\n        padding-left: 5px;\n    }\n\n    body .trade_card#tab_mobile_trade_history .table> :not(caption)>*>* {\n        padding: 5px !important;\n    }\n\n    .price_item_value span {\n        word-break: break-all;\n        white-space: nowrap;\n        line-height: 1.1;\n    }\n\n    .buysellform .input-group {\n        padding: 0px 11px;\n    }\n\n    .buysell_card {\n        /* height: 504px; */\n    }\n\n    .price_item_value span:last-child,\n    .price_card_head>div:last-child {\n        padding-right: 5px;\n    }\n\n    .buy_sell_row_price .scroll_y {\n        height: 400px;\n    }\n\n    .usd_future_dashboard .table_info_data table tr td {\n        font-size: 10px;\n    }\n\n    .usd_future_dashboard .table_info_data table tr th {\n        font-size: 10px;\n    }\n\n    .buy_sell_row_price #buy_orders .scroll_y,\n    .buy_sell_row_price #sell_orders .scroll_y {\n        height: 400px;\n    }\n\n    .spotLists {\n        width: 100%;\n        max-width: calc(100% - 12px);\n        left: 6px;\n        top: 162px;\n        min-height: 468px;\n    }\n\n    .bs_dropbox .spotLists {\n        width: 100%;\n        width: 100%;\n        max-width: 500px;\n        top: unset;\n        left: 0;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .spotLists .price_card_body.tab-content.scroll_y {\n        height: 345px;\n    }\n\n}\n\n@media screen and (max-width: 660px) {\n\n    .headline_leftItem__7BFYq {\n        font-size: 11px;\n    }\n}\n\n@media screen and (max-width: 991px) and (min-width: 320px) {\n\n    /* .bs_dropbox .summay_dasboard_pop {\n        display: block !important;\n    } */\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card {\n        width: 100%;\n        min-height: 100%;\n    }\n\n    div#tab_4 {\n        margin-top: -0.5rem;\n    }\n\n    .bs_dropbox .col-lg-6 {\n        padding: 0px;\n    }\n\n    .summay_dasboard_pop {\n        height: auto !important;\n        width: 40%;\n        border-radius: 0px !important;\n    }\n\n\n    .bs_dropbox {\n        position: fixed;\n        width: 100%;\n        background: #000000d6;\n        top: 0;\n        bottom: 0;\n        z-index: 999999;\n        left: 0;\n        display: flex;\n        align-items: end;\n        justify-content: center;\n        min-width: 100%;\n        max-width: 100%;\n    }\n\n    .trade-wrapper .bs_dropbox .row {\n        width: 100%;\n    }\n\n    .bs_dropbox .buysell_card {\n        height: auto;\n        width: 100%;\n        max-width: 100%;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        overflow-y: auto;\n        max-height: 100%;\n        background-color: #111114;\n    }\n\n    .bs_dropbox .summay_dasboard_pop {\n        padding: 0px 3px;\n    }\n\n    .bs_dropbox .price_card_head>div {\n        font-size: 8px;\n    }\n\n    .bottm_lightbox_two {\n        height: 80vh;\n    }\n\n    .bottm_lightbox_two .trade_card,\n    .spotLists {\n        border: none;\n        border-radius: 0px;\n    }\n\n    .bottm_lightbox_two .assets_btn {\n        flex-direction: row;\n    }\n\n    .bottm_lightbox_two .assets_list {\n        margin: 10px 20px 20px;\n    }\n\n    .bs_dropbox .buysell_card .btn-mini {\n        font-size: 12px !important;\n        padding: 10px 10px 9px;\n    }\n\n    .bs_dropbox .bs_box_header {\n        margin-bottom: 3px;\n    }\n\n    .bs_dropbox .spot_limit select {\n        background: transparent !important;\n        box-shadow: none;\n        -webkit-backdrop-filter: blur(10px);\n        backdrop-filter: blur(10px);\n        border: none;\n        padding: 0px;\n        min-width: unset;\n        border-radius: 0px !important;\n    }\n\n    .bs_dropbox .buysell_card .p-2.p-md-3 {\n        padding: 15px !important;\n    }\n\n    .bs_dropbox .price_card_body.scroll_y.scroll_y_reverse {\n        align-items: normal;\n        justify-content: start;\n        max-height: 100%;\n        min-height: 100%;\n        height: 100%;\n    }\n\n    .bs_dropbox .buysell_heder .custom-tabs li.buysell-tab.buy-tab a {\n        border-radius: 0px;\n    }\n\n    .bs_dropbox .buysell_heder .custom-tabs li a {\n        border-radius: 0px;\n    }\n\n    .bs_dropbox .trade_card.trade_chart.buysell_card .assets_list {\n        margin: 0px 15px 15px;\n    }\n\n\n    .bs_dropbox .buysellform .input-group .form-control {\n        font-size: 11px !important;\n        padding: 3px 6px;\n    }\n\n    .bs_dropbox .price_card_body.scroll_y {\n        max-height: 39%;\n        min-height: 39%;\n        overflow: auto;\n    }\n\n    .bs_dropbox .buysell_card.trade_chart .form-select-sm {\n        padding: 0px !important;\n        font-size: 11px;\n    }\n\n    .bs_dropbox .buysellform .input-group {\n        padding: 7px 7px 7px 3px;\n    }\n\n    .bs_dropbox .btn-group.btn-group-mini * {\n        font-size: 10px !important;\n    }\n\n    .bs_dropbox .assets_list h4 {\n        font-size: 15px;\n    }\n\n    .bs_dropbox a.more_btn {\n        font-size: 11px;\n    }\n\n    .bs_dropbox .assets_list .top_heading {\n        flex-direction: row;\n    }\n\n    .bs_dropbox .buysell_heder {\n        padding: 13px 15px !important;\n    }\n\n    .bs_dropbox .buysell_heder .custom-tabs li a {\n        padding: 4px 0;\n        font-size: 12px;\n        font-weight: 600;\n    }\n\n\n    .headline_extendInfoWrapper__dooIS,\n    .headline_left__lBBPY,\n    .headline_wrapper__BKn9L {\n        display: flex;\n        align-items: start;\n    }\n\n    .bs_dropbox.active {\n        display: flex !important;\n    }\n}\n\n@media (max-width: 480px) {\n\n    #tab_1 {\n        height: 400px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
